/* eslint-disable no-unused-vars */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable indent */
/* eslint-disable no-trailing-spaces */
/* eslint-disable quotes */

import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
// Add this import at the top with your other imports
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import { useSearchParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import { getRouterDetails } from '../utils/routerDetails';
import { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup
    // ... your existing imports
} from '@mui/material';

import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Paper,
  InputAdornment,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableFooter,
  List,
  ListItem,
  ListItemText,
  AlertTitle
} from '@mui/material';
import { useRole } from '../contexts/RoleContext';
import ApiService from '../services/ApiService';
import InfoIcon from '@mui/icons-material/Info';
import ExcelDropdown from '../components/ExcelDropdown';
import CircuitSelection from '../components/CircuitSelection';
import AGNWebexDecommissioningForm from '../odmtypes/agn_webex_decommissioning/components/AGNWebexDecommissioningForm';
import AGNIPTDecommissioningForm from '../odmtypes/agn_ipt_decommissioning/components/AGNIPTDecommissioningForm';
import { useExternalDemandLoad } from '../hooks/useExternalDemandLoad';
import CircuitOrderForm from '../odmtypes/circuit_ordering/components/CircuitOrderForm';
import NewSiteOrderingForm from '../odmtypes/new_site_ordering/components/NewSiteOrderingForm';
import SiteExpansionForm from '../odmtypes/site_expansion/components/SiteExpansionForm';
const AGNFirewallForm = lazy(() => import('../odmtypes/agn_managed_firewall/components/AGNFirewallForm'));

// Add this component in NewRequest.js


const NewRequest = () => {
  const { control, handleSubmit, watch, getValues, formState: { errors }, setValue, trigger } = useForm(); 
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogTitle, setDialogTitle] = useState('');
  const [costDialogOpen, setCostDialogOpen] = useState(false);
  const [estimatedCost, setEstimatedCost] = useState({
    total: 0,
    breakdown: {
      sdWanCircuits: 0,
      sdWanManagement: 0,
      sdWanRouter: 0,
      sdWanImacd: 0,
      accentureEffort: 0,
      sdWanEffort: 361.3,  // 2 PD × €180.65/PD
      odmTeamEffort: 924.00  // 2 PD × €462/PD
    }
  });
  const [formData, setFormData] = useState(null);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [grmNumberError, setGrmNumberError] = useState(null);
  const [isGrmNumberValid, setIsGrmNumberValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  // Add these state variables for update mode
  const [searchParams] = useSearchParams();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [requestData, setRequestData] = useState(null);
  const [isGrmTyping, setIsGrmTyping] = useState(false);
  const [grmFormatError, setGrmFormatError] = useState(null);
  const [debtorError, setDebtorError] = useState(null);
  const [isDebtorValid, setIsDebtorValid] = useState(true);
  const [isDebtorTyping, setIsDebtorTyping] = useState(false);
  const [oeNameError, setOeNameError] = useState(null);
  const [isOeNameValid, setIsOeNameValid] = useState(true);
  const [isOeNameTyping, setIsOeNameTyping] = useState(false);
  const [siteIdError, setSiteIdError] = useState(null);
  const [isSiteIdValid, setIsSiteIdValid] = useState(true);
  const [siteDetailsLoading, setSiteDetailsLoading] = useState(false);
  const [siteDetailsError, setSiteDetailsError] = useState(null);
  const navigate = useNavigate();
  const userRole = useRole();
  const requestType = watch('odmType');

  // External demand loading hook
  const {
    loading: externalLoading,
    error: externalError,
    demandData,
    isExternal,
    grmDemandNumber
  } = useExternalDemandLoad();

  // Add these state variables at the top of your component with other state declarations
  const [customerPhoneError, setCustomerPhoneError] = useState(null);
  const [isCustomerPhoneValid, setIsCustomerPhoneValid] = useState(true);
  const [isCustomerPhoneTyping, setIsCustomerPhoneTyping] = useState(false);

  const [techUserPhoneError, setTechUserPhoneError] = useState(null);
  const [isTechUserPhoneValid, setIsTechUserPhoneValid] = useState(true);
  const [isTechUserPhoneTyping, setIsTechUserPhoneTyping] = useState(false);

  const [isTechUserEmailValid, setIsTechUserEmailValid] = useState(true);
  const [techUserEmailError, setTechUserEmailError] = useState(null);

  // Add these new state variables
  const [providerOptions, setProviderOptions] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [isProviderSelected, setIsProviderSelected] = useState(false);
  const location = useLocation();
  // Add these state variables with your other state declarations
  const [costCentreError, setCostCentreError] = useState(null);
  const [isCostCentreValid, setIsCostCentreValid] = useState(true);
  const [isCostCentreTyping, setIsCostCentreTyping] = useState(false);

  // Add these state variables
  const [currentBWError, setCurrentBWError] = useState(null);
  const [isCurrentBWValid, setIsCurrentBWValid] = useState(true);
  const [isCurrentBWTyping, setIsCurrentBWTyping] = useState(false);

  // Add these state variables
  const [dateError, setDateError] = useState(null);
  const [isDateValid, setIsDateValid] = useState(true);

  // Add state variables for New Bandwidth validation
  const [newBWError, setNewBWError] = useState(null);
  const [isNewBWValid, setIsNewBWValid] = useState(true);
  const [isNewBWTyping, setIsNewBWTyping] = useState(false);

  // Add near the top of your component with other state variables
  const [availableCircuits, setAvailableCircuits] = useState([]);
  const [selectedCircuits, setSelectedCircuits] = useState([]);
  const [circuitError, setCircuitError] = useState(null);
  const [circuitBandwidths, setCircuitBandwidths] = useState({});
  const [newBandwidths, setNewBandwidths] = useState({});
  const [accessBandwidths, setAccessBandwidths] = useState({});

  // Add these new state variables near your other state declarations
  const [isCalculatingCosts, setIsCalculatingCosts] = useState(false);

  // Add these state variables with your other state declarations
  const [bandwidthErrors, setBandwidthErrors] = useState({});
  const [suggestedBandwidths, setSuggestedBandwidths] = useState({});
  const [isTyping, setIsTyping] = useState({});

  // Add these state variables with your other state declarations
  const [selectedRouterOption, setSelectedRouterOption] = useState(null);
  const [routerOptions, setRouterOptions] = useState([]);

  // ... existing code ...

  // Move RouterSelectionSection INSIDE the NewRequest component
  
// Replace your RouterSelectionSection component with this enhanced version:

const RouterSelectionSection = () => {
    if (!routerOptions || routerOptions.length <= 1) return null;

    const handleRouterChange = (selectedModel) => {
        const selected = routerOptions.find(option => option.model === selectedModel);
        if (!selected) return;
        
        setSelectedRouterOption(selected);
        
        // Calculate the difference in router cost
        const currentRouterCost = selectedRouterOption ? selectedRouterOption.price : 0;
        const newRouterCost = selected.price;
        const costDifference = newRouterCost - currentRouterCost;
        
        // Update the cost breakdown dynamically
        setEstimatedCost(prev => {
            const newTotal = prev.total + costDifference;
            const newBreakdown = {
                ...prev.breakdown,
                sdWanRouter: newRouterCost
            };
            
            console.log(`Router cost change: €${currentRouterCost} → €${newRouterCost} (difference: €${costDifference})`);
            console.log(`Total cost updated: €${prev.total} → €${newTotal}`);
            
            return {
                ...prev,
                total: newTotal,
                breakdown: newBreakdown
            };
        });
        
        console.log(`Router selection changed to: ${selected.model} (€${selected.price})`);
    };

    return (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
            <Typography variant="h6" gutterBottom>
                Options Available - Router Selection (Hard Upgrade Required)
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Second Option Listed is Recommended One as per the capcitiy - Multiple router options available based on capacity utilization:
            </Typography>
            
            <FormControl component="fieldset">
                <RadioGroup
                    value={selectedRouterOption?.model || ''}
                    onChange={(e) => handleRouterChange(e.target.value)}
                >
                    {routerOptions.map((option) => (
                        <FormControlLabel
                            key={option.model}
                            value={option.model}
                            control={<Radio />}
                            label={
                                <Box>
                                    <Typography variant="body1" fontWeight={500}>
                                        {option.model}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Capacity: {option.capacity} Mbps | Utilization: {option.utilization} | Cost: €{option.price.toFixed(2)}
                                        <br />
                                        {getRouterDetails(option.model).size} - Material: {getRouterDetails(option.model).material_number}
                                    </Typography>
                                </Box>
                            }
                            sx={{ 
                                mb: 1, 
                                p: 1, 
                                border: selectedRouterOption?.model === option.model ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                borderRadius: 1,
                                '&:hover': { backgroundColor: '#f5f5f5' }
                            }}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
            
            <Typography variant="caption" sx={{ display: 'block', mt: 1, fontStyle: 'italic', color: '#666' }}>
                Router selection is based on throughput utilization thresholds (≤70%, 71-85%, Greater than 85%)
            </Typography>
        </Box>
    );
};


  // Add this cost descriptions object near the top of your component
  const costComponentDescriptions = {
    sdWanCircuits: "SD-WAN underlay circuit cost covering the monthly costs from the WAN circuit service provider",
    sdWanManagement: "AzT SD-WAN management monthly recurring charges covering the costs for the license bandwidth",
    sdWanRouter: "AzT SD-WAN router monthly recurring charges",
    sdWanImacd: "SD-WAN underlay circuit costs covering the onetime costs from the WAN circuit service provider.",
    accentureEffort: "Implementation costs for works in scope of this ODM. The costs covers the efforts from the Integrator.",
    sdWanEffort: "AzT SD-WAN team efforts covering the costs for the efforts from the Allianz SD-WAN technical team.",
    odmTeamEffort: "ODM team effort covering the costs for ODM request processing and coordination."
  };
  // Add this helper component before your NewRequest component
  const InfoTooltip = ({ description }) => (
    <Tooltip title={description} arrow placement="right">
      <HelpOutlineIcon
        fontSize="small"
        sx={{
          ml: 0.5,
          color: 'text.secondary',
          fontSize: '16px',
          cursor: 'help',
          "&:hover": { color: 'primary.main' }
        }}
      />
    </Tooltip>
  );


  const validateGrmNumber = async (value) => {
    // First validate the format
    if (!/^[A-Za-z]{4}[0-9]{7}$/.test(value)) {
      setGrmFormatError('GRM No must be 4 letters followed by 7 numbers (e.g., DMND1234567)');
      setIsGrmNumberValid(false);
      return false;
    }

    // Clear format error if format is valid
    setGrmFormatError(null);

    try {
      // Check with the generic endpoint that searches across all request tables
      const response = await ApiService.checkGrmNumber(value);
      if (response.exists) {
        setGrmNumberError(`GRM No already exists in ${response.request_type} (ID: ${response.request_id})`);
        setIsGrmNumberValid(false);
        return false;
      } else {
        setGrmNumberError(null);
        setIsGrmNumberValid(true);
        return true;
      }
    } catch (error) {
      console.error('Error validating GRM number:', error);
      setGrmNumberError('Error validating GRM number. Please try again.');
      setIsGrmNumberValid(false);
      return false;
    }
  };
  // Replace your existing validateGrmNumber function with this enhanced version


  // Update the onSubmit function to include OE Name validation
  const onSubmit = async (data) => {
    // Check if request is already submitted
    if (isUpdateMode && requestData && requestData.request_state === 'Submitted') {
      setDialogTitle('Information');
      setDialogMessage('This request is already submitted and cannot be modified.');
      setDialogOpen(true);
      return;
    }

    // Set proper flags for update mode
    if (isUpdateMode) {
      console.log("Processing update for request:", updateId);

      // Ensure numberOfLinks is set correctly based on selected circuits
      if (selectedCircuits.length > 0) {
        setValue('numberOfLinks', selectedCircuits.length.toString());
      }
    }

    setIsCalculatingCosts(true);
    try {
      // Validate if site has active circuits
      if (siteDetailsError && siteDetailsError.includes("No active circuits found")) {
        setDialogOpen(true);
        setDialogTitle('Validation Error');
        setDialogMessage('This site has no active circuits. Please select a different site ID.');
        setIsCalculatingCosts(false);
        return;
      }

      // First validate circuits are selected if provider is selected
      if (selectedProvider && selectedCircuits.length === 0) {
        setCircuitError("At least one circuit must be selected");
        setIsCalculatingCosts(false);
        return;
      }

      // Verify all new bandwidths are entered for selected circuits
      if (selectedCircuits.length > 0) {
        let missingBandwidth = false;
        selectedCircuits.forEach(circuit => {
          if (!newBandwidths[circuit]) {
            missingBandwidth = true;
          }
        });

        if (missingBandwidth) {
          setCircuitError("New bandwidth must be specified for all selected circuits");
          setIsCalculatingCosts(false);
          return;
        }
      }

      // Process the circuit data
      if (selectedCircuits.length > 0) {
        // Store circuit data in structured format
        const circuitDetails = selectedCircuits.map(circuit => ({
          id: circuit,
          currentBandwidth: circuitBandwidths[circuit] === "Empty in TMP file"
            ? "Empty in TMP file"
            : (circuitBandwidths[circuit] || "Not specified"),
          newBandwidth: newBandwidths[circuit],
          access_bandwidth: accessBandwidths[circuit]
        }));

        // Format for display and API compatibility
        data.availableCircuit = selectedCircuits.join(', ');

        // Format both bandwidths in a readable format
        data.currentBandwidth = circuitDetails.map(c =>
          c.currentBandwidth === "Empty in TMP file"
            ? `${c.id}: Empty in TMP file`
            : `${c.id}: ${c.currentBandwidth} Mbps`
        ).join(' | ');

        // Format new bandwidths
        data.newBandwidth = circuitDetails.map(c =>
          `${c.id}: ${c.newBandwidth} Mbps`
        ).join(' | ');

        // IMPORTANT: Explicitly set the numberOfLinks field to fix validation issues
        data.numberOfLinks = selectedCircuits.length.toString();
        setValue('numberOfLinks', selectedCircuits.length.toString());

        // Store full circuit details as JSON for future reference
        data.circuitDetails = JSON.stringify(circuitDetails);

        console.log("Circuit data processed:", {
          availableCircuit: data.availableCircuit,
          currentBandwidth: data.currentBandwidth,
          newBandwidth: data.newBandwidth,
          numberOfLinks: data.numberOfLinks,
          circuitDetails: circuitDetails
        });
      }

      // Calculate cost estimate (now async) - this will determine if standard or non-standard
      const costData = await generateCostEstimate();
      setEstimatedCost(costData);

      // Determine if this is a standard or non-standard request based on the cost calculation
      const isStandard = costData.standard || false;
      console.log(`Request type determined: ${isStandard ? 'Standard' : 'Non-Standard'}`);

      // Add update mode information to the form data for proper routing
      const enrichedData = {
        ...data,
        isUpdateMode,
        updateId,
        // Add requestType to match the backend field expectation
        requestType: data.odmType,
        // Ensure submission date is set for new submissions
        submissionDate: new Date().toISOString(),
        // Set appropriate status based on standard/non-standard
        requestState: 'Submitted',
        requestStatus: 'Work in Progress',
        approvalStatus: isStandard ? 'Approved' : 'Getting Quotation',
        // Add standard flag
        standard: isStandard ? 'Yes' : 'No'
      };

      // Store enriched data in form state
      setFormData({
        ...data,
        costEstimate: costData.total,
        costEstimateDetails: JSON.stringify(costData),
        requestState: 'Submitted',
        requestStatus: 'Work in Progress', // 🔧 FIX: Ensure this is set correctly
        standard: costData.standard ? 'Yes' : 'No'  // Add this line to fix standard flag
      });

      // Complete processing
      setIsCalculatingCosts(false);
      setCostDialogOpen(true);
    } catch (error) {
      console.error("Error during cost calculation:", error);
      setIsCalculatingCosts(false);
      setDialogOpen(true);
      setDialogTitle('Error');
      setDialogMessage('There was an error calculating the cost estimate. Please try again.');
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    if (dialogTitle === 'Success') {
      ApiService.invalidateRequestsCache();
      navigate('/track-requests');
    }
  };

  const handleRequestTypeChange = (value) => {
    setShowAdditionalFields(value !== '');
  };

  // Updated handleSave to trigger the dialog instead of saving directly
  const handleSave = async () => {
    // Trigger validation for all fields to show errors
    const validationResult = await trigger();

    if (!validationResult) {
      // Show error dialog with more helpful message
      setDialogTitle('Validation Error');
      setDialogMessage('Please complete all required fields marked in red before saving.');
      setDialogOpen(true);
      return;
    }

    // Get current form values after validation
    const data = getValues();

    // If we've shown additional fields but provider is selected without circuits
    if (showAdditionalFields && selectedProvider && selectedCircuits.length === 0) {
      setCircuitError("At least one circuit must be selected");
      setDialogTitle('Validation Error');
      setDialogMessage('Please select at least one circuit before saving.');
      setDialogOpen(true);
      return;
    }

    // Add this bandwidth validation check
    if (selectedCircuits.length > 0 && !hasValidBandwidths()) {
      setDialogTitle("Validation Error");
      setDialogMessage("Please enter valid new bandwidth values for all selected circuits.");
      setDialogOpen(true);
      return;
    }

    setIsCalculatingCosts(true);

    try {
      // Format circuit data
      let circuitData = {};
      if (selectedCircuits.length > 0) {
        selectedCircuits.forEach(circuit => {
          circuitData[circuit] = {
            currentBandwidth: circuitBandwidths[circuit] || '',
            newBandwidth: newBandwidths[circuit] || ''
          };
        });
      }

      // Format the request data
      const formattedData = {
        odmTitle: data.odmTitle,
        odmType: data.odmType,
        grmDemandNumber: data.grmDemandNumber,
        oeName: data.oeName,
        costCentre: data.costCentre,
        debtor: data.debtor,
        siteId: data.siteId,
        siteAddress: data.siteAddress,
        city: data.city,
        country: data.country,
        siteType: data.siteType,
        currentProvider: data.currentProvider,
        linkType: data.linkType,
        routerModel: data.routerModel,
        numberOfLinks: selectedCircuits.length.toString(),
        availableCircuit: selectedCircuits.join(','),
        currentBandwidth: Object.entries(circuitBandwidths)
          .map(([circuit, bw]) => `${circuit}: ${bw} Mbps`)
          .join(', '),
        newBandwidth: Object.entries(newBandwidths)
          .map(([circuit, bw]) => `${circuit}: ${bw} Mbps`)
          .join(', '),
        descriptionOfOdmRequest: data.descriptionOfOdmRequest,
        businessReasons: data.businessReasons,
        desiredDateOfInstallation: data.desiredDateOfInstallation,
        customerName: data.customerName,
        customerContactMail: data.customerContactMail,
        customerContactPhone: data.customerContactPhone,
        siteTechnicalUserName: data.siteTechnicalUserName,
        siteTechnicalUserEmail: data.siteTechnicalUserEmail,
        siteTechnicalUserPhone: data.siteTechnicalUserPhone,
        requestState: 'Draft'
      };

      // Calculate costs
      const costResult = await generateCostEstimate();
      setEstimatedCost(costResult);

      // Add cost data
      formattedData.costEstimate = costResult.total.toString();
      formattedData.costEstimateDetails = JSON.stringify(costResult);

      // Store the formatted data and updateId for use in handleSaveAsDraft
      setFormData({
        ...formattedData,
        isUpdateMode,
        updateId
      });

      // Now show the save dialog
      setSaveDialogOpen(true);

    } catch (error) {
      console.error('Error preparing request data:', error);
      setDialogTitle('Error');
      setDialogMessage(`Failed to prepare request data: ${error.message}`);
      setDialogOpen(true);
    } finally {
      setIsCalculatingCosts(false);
    }
  };

  // Update generateCostEstimate to include router costs properly
  // Update generateCostEstimate to include router costs properly
  const generateCostEstimate = async () => {
    try {
      // Prepare circuit data
      const circuitData = selectedCircuits.map(circuit => ({
        id: circuit,
        newBandwidth: newBandwidths[circuit]
      }));

      // Get country from form
      const country = getValues().country || '';

      console.log("Calculating costs for circuits:", circuitData);
      console.log("Country:", country);

      // Static cost for SD-WAN Management (always fixed at 2560)
      const sdWanManagementCost = calculateSdWanManagementCost(circuitData);
      console.log(`Total SDWAN Management cost: €${sdWanManagementCost.toFixed(2)}`);

      // If no circuits are selected, just return the management cost
      if (circuitData.length === 0) {
        return {
          total: sdWanManagementCost,
          breakdown: {
            sdWanCircuits: 0,
            sdWanManagement: sdWanManagementCost,
            sdWanRouter: 0,
            sdWanImacd: 0,
            accentureEffort: 0,
            sdWanEffort: 361.3,  // 2 PD × €174.07/PD
            odmTeamEffort: 924.00  // 2 PD × €462/PD
          },
          standard: true, // Default to standard if no circuits
          upgradeType: "none" // No upgrade type for empty circuits
        };
      }

      // Calculate dynamic costs from backend
      const costResult = await ApiService.calculateCircuitCosts(
        circuitData,
        country,
        getValues().siteType || "Normal Site" // Add site type to the API call
      );

      console.log("Cost calculation result:", costResult);

       // NEW: Extract router options if available
        const firstCircuit = costResult.circuitCosts?.[0];
        if (firstCircuit?.routerOptions && firstCircuit.routerOptions.length > 0) {
            setRouterOptions(firstCircuit.routerOptions);
            setSelectedRouterOption(firstCircuit.routerOptions[0]); // Default to first
            console.log(`Router options available: ${firstCircuit.routerOptions.length}`);
            firstCircuit.routerOptions.forEach((option, index) => {
                console.log(`Option ${index + 1}: ${option.model} (${option.capacity} Mbps, €${option.price}, ${option.utilization})`);
            });
        } else {
            setRouterOptions([]);
            setSelectedRouterOption(null);
        }

      // Determine if this is a standard or non-standard request
      const isStandard = isStandardRequest(costResult);
      console.log(`Request type: ${isStandard ? 'Standard' : 'Non-Standard'}`);

      // IMPORTANT FIX: Check circuit-specific upgrade types from the backend
      const upgradeTypes = costResult.details?.upgradeTypes || {};

      // If any circuit requires a hard upgrade, the overall type is hard
      let hasHardUpgrade = false;
      Object.values(upgradeTypes).forEach(type => {
        if (type === "hard") {
          hasHardUpgrade = true;
        }
      });

      // Set overall upgrade type based on individual circuit types
      const overallUpgradeType = hasHardUpgrade ? "hard" : "soft";
      console.log(`Overall bandwidth upgrade type: ${overallUpgradeType} (based on individual circuit types)`);

      // Extract costs directly from backend breakdown (already includes VAT for Germany)
      const sdWanCircuitCost = costResult.breakdown?.sdWanCircuits || 0;

      // Get router cost from backend calculation (already includes VAT for Germany)
      const sdWanRouterCost = costResult.totalRouterCost || 0;

      // IMACD cost from backend breakdown (already includes VAT for Germany)
      const sdWanImaCdCost = costResult.breakdown?.sdWanImacd || 0;
      const accentureEffortCost = costResult.accentureEffort?.total || 0;
      const sdWanEffortCost = 361.3;  // 2 PD × €180.65/PD
      const odmTeamEffortCost = 924.00;  // 2 PD × €462/PD

      // Calculate total (including the fixed management cost)
      const totalCost = sdWanManagementCost + sdWanCircuitCost + sdWanRouterCost + sdWanImaCdCost + accentureEffortCost + sdWanEffortCost + odmTeamEffortCost;

      // Calculate range for non-standard requests (base + 50%)
      const upperRangeTotal = isStandard ?
        totalCost :
        Math.max(399, Math.round((totalCost + (totalCost * 0.5)) * 100) / 100);

      // Add circuit-specific upgrade types to the circuit details if missing
      if (costResult.circuitCosts && Array.isArray(costResult.circuitCosts)) {
        costResult.circuitCosts.forEach(circuit => {
          if (circuit.id && upgradeTypes[circuit.id]) {
            circuit.upgradeType = upgradeTypes[circuit.id];
          }
        });
      }

      return {
        total: Math.round(totalCost * 100) / 100, // Round to 2 decimal places
        upperRangeTotal: Math.round(upperRangeTotal * 100) / 100, // Upper bound for range
        breakdown: {
          sdWanCircuits: Math.round(sdWanCircuitCost * 100) / 100,
          sdWanManagement: sdWanManagementCost,
          sdWanRouter: Math.round(sdWanRouterCost * 100) / 100,
          sdWanImacd: Math.round(sdWanImaCdCost * 100) / 100,
          accentureEffort: parseFloat(accentureEffortCost.toFixed(2)),
          sdWanEffort: 361.3,  // 2 PD × €180.65/PD
          odmTeamEffort: 924.00  // 2 PD × €462/PD
        },
        details: {
          circuitDetails: costResult.circuitCosts || [],
          countryUplift: costResult.countryUplift || 0,
          imacdUplift: costResult.imacdUplift || 0.0782,
          routerCosts: costResult.routerCosts || {},
          accentureEffortDetails: costResult.accentureEffort?.details || [],
          errors: costResult.errors || [],
          upgradeTypes: upgradeTypes // Include the circuit-specific upgrade types
        },
        standard: isStandard, // Flag indicating if this is a standard request
        upgradeType: overallUpgradeType // Overall upgrade type based on individual circuits
      };
    } catch (error) {
      console.error("Error generating cost estimate:", error);

      // Return a fallback cost on error
      return {
        total: 2560, // Default to just management cost on error
        upperRangeTotal: 3840, // 50% more than base
        breakdown: {
          sdWanCircuits: 0,
          sdWanManagement: 2560,
          sdWanRouter: 0,
          sdWanImacd: 0,
          accentureEffort: 0,
          sdWanEffort: 361.3,  // 2 PD × €180.65/PD
          odmTeamEffort: 924.00  // 2 PD × €462/PD
        },
        details: {
          errors: [`Error calculating costs: ${error.message}`]
        },
        standard: false, // Default to non-standard on error
        upgradeType: "unknown" // Unknown upgrade type on error
      };
    }
  };

  // Update the handleSaveAsDraft function to include OE Name validation
  // Updated handleSaveAsDraft function - ONLY for drafts
  // Updated handleSaveAsDraft function - ONLY for drafts
  // Restore the original handleSaveAsDraft function
  const handleSaveAsDraft = async () => {
    setSaveDialogOpen(false);
    setIsSaving(true);

    try {
      // Use the formData that includes isUpdateMode and updateId
      const requestData = formData;
      console.log('Saving draft with data:', requestData);

      let response;

      if (requestData.isUpdateMode) {
        // Update existing request
        console.log(`Updating request ID ${requestData.updateId} as draft`);
        response = await ApiService.put(`/api/requests/${requestData.updateId}`, requestData);
        setDialogTitle('Success');
        ApiService.invalidateRequestsCache();
        setDialogMessage('Request updated successfully!');
      } else {
        // Create new request
        console.log('Creating new draft request');
        response = await ApiService.post('/api/requests/', requestData);
        setDialogTitle('Success');
        ApiService.invalidateRequestsCache();
        setDialogMessage('Request saved as draft successfully!');
      }

      setIsSaving(false);
      setDialogOpen(true);
    } catch (error) {
      setIsSaving(false);
      console.error('Error saving request as draft:', error);
      setDialogTitle('Error');
      setDialogMessage(`Failed to save draft: ${error.message}`);
      setDialogOpen(true);
    }
  };

  // Add this function to check if all circuits have valid bandwidth values
  const hasValidBandwidths = () => {
  // Check if we have selected circuits but missing bandwidth values
  if (selectedCircuits.length === 0) return true;

  // Check if any selected circuit is missing a bandwidth or has CRITICAL errors
  for (const circuit of selectedCircuits) {
    if (!newBandwidths[circuit]) {
      return false; // Missing bandwidth
    }
    
    // 🔧 CHANGE: Only block for CRITICAL errors, not warnings
    const error = bandwidthErrors[circuit];
    if (error && !error.startsWith('⚠️')) {
      // Only block if it's a critical error (not a warning with ⚠️)
      return false;
    }
    
    // Additional check: ensure it's a valid positive number
    const value = parseFloat(newBandwidths[circuit]);
    if (isNaN(value) || value <= 0) {
      return false;
    }
  }
  return true;
};

  // Add this function to your component
  const onFormInvalid = (errors) => {
    console.log('Form errors:', errors);
    setDialogOpen(true);
    setDialogTitle('Validation Error');
    setDialogMessage('Please fill in all required fields before proceeding.');
  };

  // Updated handleApprove function
 // Replace your handleApprove function with this enhanced version:
// Replace your handleApprove function with this enhanced version:
const handleApprove = async () => {
  // Inside handleApprove function, before setting updatedFormData
  console.log("Standard flag:", formData.standard);
  console.log("Is standard request:", formData.standard === 'Yes');

  setCostDialogOpen(false);
  setIsSubmitting(true); // Use isSubmitting, NOT isSaving

  try {
    // Make sure we have the formData
    if (!formData) {
      setDialogTitle('Error');
      setDialogMessage('No form data available to submit. Please try again.');
      setDialogOpen(true);
      setIsSubmitting(false);
      return;
    }

    // **NEW: Router Selection Logic** - Only apply if user made a selection
    let updatedFormData = { ...formData };
    
    if (selectedRouterOption && routerOptions.length > 1) {
      console.log(`User selected router: ${selectedRouterOption.model} (€${selectedRouterOption.price})`);
      
      // Update cost estimate details to reflect the selected router
      const updatedCostDetails = JSON.parse(updatedFormData.costEstimateDetails);
      
      // Update the circuit cost data with selected router
      if (updatedCostDetails.circuitCosts && updatedCostDetails.circuitCosts[0]) {
        updatedCostDetails.circuitCosts[0].newRouterModel = selectedRouterOption.model;
        updatedCostDetails.circuitCosts[0].routerCost = selectedRouterOption.price;
        
        // Remove routerOptions - we only keep the selected one
        delete updatedCostDetails.circuitCosts[0].routerOptions;
        delete updatedCostDetails.circuitCosts[0].defaultRouter;
      }
      
      // Update router costs in breakdown
      updatedCostDetails.routerCosts = {
        [selectedRouterOption.model]: selectedRouterOption.price
      };
      updatedCostDetails.totalRouterCost = selectedRouterOption.price;
      
      // Update breakdown
      updatedCostDetails.breakdown.sdWanRouter = selectedRouterOption.price;
      
      // Update the circuit details section
      if (updatedCostDetails.details && updatedCostDetails.details.circuitDetails) {
        updatedCostDetails.details.circuitDetails.forEach(circuit => {
          if (circuit.upgradeType === "hard" || circuit.upgrade_type === "hard") {
            circuit.newRouterModel = selectedRouterOption.model;
            circuit.new_router_model = selectedRouterOption.model;
            circuit.routerCost = selectedRouterOption.price;
            console.log(`Updated circuit ${circuit.id} with selected router: ${selectedRouterOption.model}`);
          }
        });
      }
      
      // Update financial section if it exists
      if (updatedCostDetails.financial && updatedCostDetails.financial.circuit_details) {
        updatedCostDetails.financial.circuit_details.forEach(circuit => {
          if (circuit.upgrade_type === "hard") {
            circuit.new_router_model = selectedRouterOption.model;
            console.log(`Updated financial circuit ${circuit.circuit_id} with selected router: ${selectedRouterOption.model}`);
          }
        });
      }
      
      // Recalculate total cost
      const newTotal = Object.values(updatedCostDetails.breakdown).reduce((sum, cost) => sum + cost, 0);
      updatedCostDetails.total = newTotal;
      
      // Update form data
      updatedFormData.costEstimate = newTotal;
      updatedFormData.costEstimateDetails = JSON.stringify(updatedCostDetails);
      
      console.log(`Selected router for submission: ${selectedRouterOption.model} (€${selectedRouterOption.price})`);
      console.log(`Updated total cost: €${newTotal}`);
    }

    // Determine if this is standard or non-standard
    const isStandard = updatedFormData.standard === 'Yes';

    // Set the appropriate approval status based on standard/non-standard
    updatedFormData.approvalStatus = isStandard ? 'Approved' : 'Getting Quotation';
    updatedFormData.requestState = 'Submitted';
    updatedFormData.requestStatus = 'Work in Progress';

    let response;
    if (isUpdateMode && updateId) {
      response = await ApiService.put(`/api/requests/${updateId}`, updatedFormData);
    } else {
      response = await ApiService.submitRequest(updatedFormData);
    }

    // Show success message
    setDialogTitle("Success");
    ApiService.invalidateRequestsCache();
    setDialogMessage(
      isStandard
        ? "Your request has been approved and submitted successfully!"
        : "Your request has been submitted. We will provide a quotation within 2 working weeks."
    );
    setDialogOpen(true);

    // Navigate to track-requests after a short delay
    setTimeout(() => {
      navigate("/track-requests");
    }, 3000);

  } catch (error) {
    console.error("Error submitting request:", error);
    setDialogTitle("Error");
    setDialogMessage("Failed to submit request: " + error.message);
    setDialogOpen(true);
  } finally {
    setIsSubmitting(false);  // Use isSubmitting, NOT isSaving
  }
};

  const handleReject = () => {
    setCostDialogOpen(false);
    setDialogTitle('Rejected');
    setDialogMessage('No problem, you can revisit later.');
    setDialogOpen(true);
  };

  // Update configuration for Excel-based dropdown fields to only include siteId
  const excelFieldConfig = {
    siteId: {
      columnName: "Migration ID 1",
      label: "Site ID *",
      placeholder: "COUNTRY_CITY_Number (e.g., USA_NEWJ_150287)",
      required: true
    }
  };

  // Define configuration for site-dependent fields
  const dependentFieldsConfig = {
    siteAddress: {
      label: "Site Address",
      sourceField: "site_address",
      editable: true, // This one can be edited by user
    },
    city: {
      label: "City",
      sourceField: "city",
      editable: false,
    },
    country: {
      label: "Country",
      sourceField: "country",
      editable: false,
    },
    currentProvider: {
      label: "Current Provider",
      sourceField: "current_provider",
      editable: false,
    },
    availableCircuit: {
      label: "Available Circuit",
      sourceField: "available_circuit",
      editable: false,
    }
  };

  // Add this function to handle site ID selection
  const handleSiteIdChange = async (newValue) => {
    // First, reset ALL circuit-related state to prevent persisting old data
    setSelectedCircuits([]);
    setAvailableCircuits([]);
    setCircuitBandwidths({});
    setNewBandwidths({});
    setBandwidthErrors({});
    setSuggestedBandwidths({});
    setCircuitError(null);
    setProviderOptions([]);
    setSelectedProvider(null);

    if (!newValue) {
      setSiteIdError(null);
      return;
    }

    try {
      setSiteDetailsLoading(true);
      setSiteDetailsError(null);

      // Fetch site details including all circuits
      const siteDetails = await ApiService.getSiteDetails(newValue);

      if (!siteDetails) {
        setSiteDetailsError("Failed to fetch site details");
        return;
      }

      // Update form values with site details - handle empty fields properly
      if (siteDetails.site_fields) {
        Object.entries(dependentFieldsConfig).forEach(([field, config]) => {
          if (siteDetails.site_fields && siteDetails.site_fields[config.sourceField]) {
            // Set field value
            let fieldValue = siteDetails.site_fields[config.sourceField];
            setValue(field, fieldValue);
          } else if (field !== 'currentProvider') {
            // For non-provider fields set "Empty in TMP file" if missing
            setValue(field, "Empty in TMP file");
          }
        });
      }

      // Handle providers safely - check for missing data
      const providers = siteDetails.providers || [];

      // If no providers found, set currentProvider to "Empty in TMP file"
      if (providers.length === 0) {
        setValue('currentProvider', 'Empty in TMP file');
        setSiteDetailsError("No active circuits found for this site. All circuits are out-of-service or missing. Please select a different site ID.");
        return;
      }

      // Check if each provider has any active circuits
      const providersWithCircuits = providers.filter(provider =>
        Array.isArray(provider.circuits) && provider.circuits.length > 0
      );

      if (providersWithCircuits.length === 0) {
        setValue('currentProvider', 'Empty in TMP file');
        setSiteDetailsError("No active circuits found for this site. All circuits are out-of-service. Please select a different site ID.");
        return;
      }

      // Process provider data for options
      const mappedProviderOptions = providersWithCircuits.map(provider => ({
        value: provider.provider || 'Empty in TMP file',
        circuits: Array.isArray(provider.circuits)
          ? provider.circuits.map(circuit => ({
            ...circuit,
            bandwidth: circuit.bandwidth === "Empty in TMP file"
              ? "Empty in TMP file"
              : circuit.bandwidth || "Empty in TMP file"
          }))
          : [],
        linkType: provider.link_type === "Empty in TMP file"
          ? "Empty in TMP file"
          : (provider.link_type || "Empty in TMP file"),
        routerModel: provider.router_model === "Empty in TMP file"
          ? "Empty in TMP file"
          : (provider.router_model || "Empty in TMP file"),
        mandatory: providersWithCircuits.length === 1
      }));

      // Set provider options
      setProviderOptions(mappedProviderOptions);

      // Auto-select provider if only one exists - THIS IS THE KEY FIX
      if (providersWithCircuits.length === 1) {
        const provider = providersWithCircuits[0];
        const providerValue = provider.provider || 'Empty in TMP file';

        // Set form value AND state
        setValue('currentProvider', providerValue);
        setSelectedProvider(providerValue);

        // Important: Also trigger the provider change handler
        handleProviderChange(providerValue);

        // Get circuit IDs - always extract IDs from circuit objects
        const circuits = provider.circuits || [];
        setAvailableCircuits(circuits);

        // Build bandwidth map from circuit data
        const bandwidthMap = {};
        if (Array.isArray(circuits)) {
          circuits.forEach(circuit => {
            if (typeof circuit === 'object' && circuit.id) {
              // Store mapping from circuit ID to bandwidth
              bandwidthMap[circuit.id] = circuit.bandwidth === "Empty in TMP file"
                ? "Empty in TMP file"
                : (circuit.bandwidth || "Empty in TMP file");
            } else if (typeof circuit === 'string') {
              // If circuit is already a string ID, use a default value
              bandwidthMap[circuit] = "Empty in TMP file";
            }
          });
        }
        setCircuitBandwidths(bandwidthMap);

        // Build access bandwidth map from circuit data
        const accessBandwidthMap = {};
        if (Array.isArray(circuits)) {
          circuits.forEach(circuit => {
            if (typeof circuit === 'object' && circuit.id) {
              accessBandwidthMap[circuit.id] = circuit.access_bandwidth || "Empty in TMP file";
            }
          });
        }
        setAccessBandwidths(accessBandwidthMap);

        // Also set link type and router model if available
        if (provider.linkType) {
          setValue('linkType', provider.linkType);
        } else {
          setValue('linkType', 'Empty in TMP file');
        }

        if (provider.routerModel) {
          setValue('routerModel', provider.routerModel);
        } else {
          setValue('routerModel', 'Empty in TMP file');
        }

        // Auto-select circuits if there's only one (after a slight delay)
        if (circuits.length === 1) {
          const circuitId = typeof circuits[0] === 'object' ? circuits[0].id : circuits[0];
          // Use a small delay to ensure state updates have completed
          setTimeout(() => {
            setSelectedCircuits([circuitId]);
            setValue('numberOfLinks', '1');
          }, 100);
        }
      } else {
        setValue('currentProvider', '');
        setSelectedProvider(null);
        setAvailableCircuits([]);
      }

      setValue('siteId', newValue);
      setSiteIdError(null);

    } catch (error) {
      console.error("Error fetching site details:", error);
      setSiteDetailsError(`Error: ${error.message || "Failed to fetch site details"}`);

      // Clear dependent fields on error
      Object.keys(dependentFieldsConfig).forEach(field => {
        setValue(field, '');
      });
    } finally {
      setSiteDetailsLoading(false);
    }
  };

  // Modify the handleProviderChange function:
  const handleProviderChange = (providerValue) => {
    setSelectedProvider(providerValue);

    // Find the selected provider option
    const selectedProviderOption = providerOptions.find(
      option => option.value === providerValue
    );

    // Clear previous circuit selections and bandwidths
    setSelectedCircuits([]);
    setCircuitBandwidths({});
    setNewBandwidths({});
    setBandwidthErrors({});
    setCircuitError(null);

    if (selectedProviderOption) {
      // Get circuits for this provider
      const circuits = selectedProviderOption.circuits || [];
      setAvailableCircuits(circuits);

      // Create bandwidth mappings
      const bandwidthMap = {};
      circuits.forEach(circuit => {
        if (typeof circuit === 'object' && circuit.id) {
          bandwidthMap[circuit.id] = circuit.bandwidth || '';
        } else if (typeof circuit === 'string') {
          bandwidthMap[circuit] = '';
        }
      });

      setCircuitBandwidths(bandwidthMap);

      // Set link type and router model from the provider if available
      if (selectedProviderOption.linkType) {
        setValue('linkType', selectedProviderOption.linkType);
      }

      if (selectedProviderOption.routerModel) {
        setValue('routerModel', selectedProviderOption.routerModel);
      }

      // Auto-select circuit if only one is available
      if (circuits.length === 1) {
        const circuitId = typeof circuits[0] === 'object' ? circuits[0].id : circuits[0];
        setSelectedCircuits([circuitId]);
        setValue('numberOfLinks', '1');
      }
    } else {
      // No provider selected, clear the circuits
      setAvailableCircuits([]);
    }
  };

  // Phone number validation function
  const validatePhoneNumber = (value) => {
    if (!value) return "Phone number is required"; // Changed to return error message

    // Basic validation - allow international format with country code
    const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,5}[-\s.]?[0-9]{1,9}$/;

    if (!phoneRegex.test(value)) {
      return "Please enter a valid phone number (e.g., +XX (XXX) XXX-XXXX)";
    }

    // Check minimum length (with non-digit characters removed)
    const digitsOnly = value.replace(/\D/g, '');
    if (digitsOnly.length < 7) {
      return "Phone number must have at least 7 digits";
    }

    // Check maximum length
    if (digitsOnly.length > 15) {
      return "Phone number cannot exceed 15 digits";
    }

    return null; // Validation passed
  };

  // Email validation function
  const validateEmail = (value) => {
    if (!value) return "Email is required";

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(value)) {
      return "Please enter a valid email address";
    }

    return null; // Validation passed
  };

  // Add this helper function to your component
  const logFormState = (message) => {
    console.log(`[${message}] Form state:`, {
      siteId: getValues('siteId'),
      currentProvider: getValues('currentProvider'),
      availableCircuit: getValues('availableCircuit'),
      linkType: getValues('linkType'),
      routerModel: getValues('routerModel'),
      providerOptions: providerOptions,
      selectedProvider: selectedProvider
    });
  };

  // Add a useEffect to log state changes
  useEffect(() => {
    if (providerOptions.length === 1 && providerOptions[0].value !== "Empty") {
      console.log("Only one provider found:", providerOptions[0]);
    }
  }, [providerOptions]);

  const handleCircuitSelection = (selected) => {
    setSelectedCircuits(selected);
    setCircuitError(selected.length === 0 ? "Please select at least one circuit" : null);

    // IMPORTANT: Update numberOfLinks field in React Hook Form
    setValue('numberOfLinks', selected.length.toString());

    console.log("Selected circuits updated:", selected);
  };

  // Replace your handleNewBandwidthChange function with this version
  // Replace your handleNewBandwidthChange function with this version
  // Replace your handleNewBandwidthChange function with this updated version
  const handleNewBandwidthChange = (circuit, value) => {
    // Update typing state for this circuit
    setIsTyping(prev => ({ ...prev, [circuit]: true }));

    // Store user input regardless of NaN
    const newValues = { ...newBandwidths };

    // Allow any numeric input or empty string
    if (value === '' || /^\d+$/.test(value)) {
      newValues[circuit] = value;
      setNewBandwidths(newValues);

      // Clear any error for this circuit as the user is typing
      setBandwidthErrors(prev => ({ ...prev, [circuit]: null }));
      return;
    }

    // If input is not a valid number, keep the old value but show an error
    setBandwidthErrors(prev => ({
      ...prev,
      [circuit]: "Please enter a valid number"
    }));
  };

  // Update the handleBandwidthBlur function as well to handle NaN options
  const handleBandwidthBlur = (circuit) => {
  // User has stopped typing this field
  setIsTyping(prev => ({
    ...prev,
    [circuit]: false
  }));

  const value = newBandwidths[circuit];

  // Skip validation for empty values
  if (!value || !value.trim()) {
    setBandwidthErrors(prev => ({ ...prev, [circuit]: "New bandwidth is required" }));
    return;
  }

  // Parse the input value to a number
  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    setBandwidthErrors(prev => ({ ...prev, [circuit]: "Please enter a valid number" }));
    return;
  }

  // Find the circuit data from availableCircuits
  const circuitData = availableCircuits.find(c => c.id === circuit);

  // Only validate against option1 and option2 if they are valid numbers
  if (circuitData &&
    ((!isNaN(circuitData.option1_bandwidth) && circuitData.option1_bandwidth > 0) ||
      (!isNaN(circuitData.option2_bandwidth) && circuitData.option2_bandwidth > 0))) {

    // Only check if the value matches one of the valid options
    const option1 = !isNaN(circuitData.option1_bandwidth) ? parseFloat(circuitData.option1_bandwidth) : null;
    const option2 = !isNaN(circuitData.option2_bandwidth) ? parseFloat(circuitData.option2_bandwidth) : null;

    const validOptions = [option1, option2].filter(opt => opt !== null);

    if (validOptions.length > 0 && !validOptions.includes(numValue)) {
      // 🔧 CHANGE: Show as WARNING instead of ERROR (use "warning" prefix)
      setBandwidthErrors(prev => ({
        ...prev,
        [circuit]: `⚠️ Recommended Bandwidth values Availale for PreApproved Pricing : ${validOptions.join(', ')} Mbps (you entered: ${numValue} Mbps)`
      }));
    } else {
      // Clear any error
      setBandwidthErrors(prev => ({ ...prev, [circuit]: null }));
    }
  } else {
    // If no valid options are available, just validate it's a positive number
    if (numValue <= 0) {
      setBandwidthErrors(prev => ({ ...prev, [circuit]: "Bandwidth must be greater than 0" }));
    } else {
      // Clear any error
      setBandwidthErrors(prev => ({ ...prev, [circuit]: null }));
    }
  }
};

  // Add this function to handle blur events (when user moves to next field)

  const isStandardRequest = (costResult) => {
    return costResult?.standard === true;
  };
  // Add this function near your other utility functions
  const calculateSdWanManagementCost = (circuits) => {
    const bandwidthTiers = [10, 30, 50, 100, 200, 500, 750, 1000, 2000, 5000, 10000];
    const siteType = getValues().siteType || "Normal Site";
    const country = getValues().country || "";
    const isGermany = country.toLowerCase().includes("germany");

    const siteMultiplier = siteType === "Call Center" ? 0.5 : siteType === "Data Center" ? 1.0 : 0.25;

    let totalAdjustedThroughput = 0;
    circuits.forEach(circuit => {
      const newBw = circuit.newBandwidth;
      if (!newBw) return;
      try {
        totalAdjustedThroughput += parseFloat(newBw) * 2 * siteMultiplier;
      } catch (e) {
        console.error('Error reading bandwidth for circuit:', circuit, e);
      }
    });

    const nextHigherTier = bandwidthTiers.find(t => t >= totalAdjustedThroughput) ?? bandwidthTiers[bandwidthTiers.length - 1];
    const multiplier = isGermany ? 2.92 : 2.56;
    const totalCost = nextHigherTier * multiplier;

    console.log(`SDWAN Management: siteType=${siteType} (${siteMultiplier * 100}%) → total adjusted throughput=${totalAdjustedThroughput} → tier=${nextHigherTier} → country=${isGermany ? 'Germany' : 'Non-Germany'} multiplier=${multiplier} → €${totalCost.toFixed(2)}`);

    return totalCost;
  };

  // Add this effect to load existing data when in update mode
  // Add this effect to load existing data when in update mode
  // Add this effect to load existing data when in update mode
  // Add this effect to load existing data when in update mode


  useEffect(() => {
    // Guard clause to prevent infinite loops
    if (!updateId || isUpdateMode) return;
    console.log('Loading request data for ID:', updateId);

    // 🔧 FIX: Check if this is an AGN request and skip NewRequest logic
    const searchParams = new URLSearchParams(location.search);
    const requestType = searchParams.get('type');

    if (requestType === 'agn_firewall') {
      console.log('🟠 AGN Firewall request detected - skipping NewRequest data loading');
      setIsUpdateMode(true);
      // Only set basic update mode, let AGNFirewallForm handle the data loading
      return;
    }

    if (requestType === 'agn_webex') {
      setIsUpdateMode(true);
      return;
    }

    if (requestType === 'agn_ipt') {
      console.log('🟠 AGN IPT request detected - skipping NewRequest data loading');
      setIsUpdateMode(true);
      return;
    }

    if (requestType === 'circuit_order') {
      console.log('🟠 Circuit Order detected - skipping NewRequest data loading');
      setIsUpdateMode(true);
      return;
    }

    if (requestType === 'new_site') {
      console.log('🟠 New Site Ordering detected - skipping NewRequest data loading');
      setIsUpdateMode(true);
      return;
    }

    if (requestType === 'site_expansion') {
      console.log('🟠 Site Expansion detected - skipping NewRequest data loading');
      setIsUpdateMode(true);
      return;
    }

    console.log('🔵 Loading bandwidth request data...');


    const loadExistingRequest = async () => {
      try {
        setIsUpdateMode(true);
        setIsCalculatingCosts(true);
        console.log("Loading request data for ID:", updateId);
        const data = await ApiService.get(`/api/requests/${updateId}`);

        // Store the full request data
        setRequestData(data);

        // Set form values from data
        setValue('odmTitle', data.odm_title || '');
        setValue('odmType', data.request_type || '');
        setValue('grmDemandNumber', data.grm_demand_number || '');

        // Show additional fields if we have a request type
        if (data.request_type) {
          setShowAdditionalFields(true);

          // Set other basic fields - DO NOT SET SITE-DEPENDENT FIELDS HERE
          setValue('oeName', data.oe_name || '');
          setValue('costCentre', data.cost_centre || '');
          setValue('debtor', data.debtor || '');
          setValue('siteType', data.site_type || 'Normal Site');

          // Set technical details
          setValue('routerModel', data.router_model || '');
          setValue('desiredDateOfInstallation', data.desired_date_of_installation || '');

          // Set description fields
          setValue('descriptionOfOdmRequest', data.description_of_odm_request || '');
          setValue('businessReasons', data.business_reasons || '');

          // Set contact info
          setValue('customerName', data.customer_name || '');
          setValue('customerContactMail', data.customer_contact_mail || userRole.userEmail || '');
          setValue('customerContactPhone', data.customer_contact_phone || '');
          setValue('siteTechnicalUserName', data.site_technical_user_name || '');
          setValue('siteTechnicalUserEmail', data.site_technical_user_email || '');
          setValue('siteTechnicalUserPhone', data.site_technical_user_phone || '');

          // THIS IS KEY: Set siteId last and trigger the same site details fetch that happens in normal mode
          if (data.site_id) {
            console.log("Setting site ID and triggering site details fetch:", data.site_id);
            setValue('siteId', data.site_id);

            // Important: Call the same handler that's used when selecting a site in normal mode
            await handleSiteIdChange(data.site_id);

            // Add after await handleSiteIdChange(data.site_id); in your loadExistingRequest function
            // Inside your loadExistingRequest function, right after parsing the request_details_json

            if (data.request_details_json) {
              try {
                const detailsJson = JSON.parse(data.request_details_json);

                // First look for new bandwidth values in network_details.circuits
                if (detailsJson.network_details?.circuits && Array.isArray(detailsJson.network_details.circuits)) {
                  console.log("Found circuit details in network_details:", detailsJson.network_details.circuits);

                  // Extract circuit data and new bandwidth directly
                  const networkCircuits = detailsJson.network_details.circuits;
                  const circuitIds = networkCircuits.map(circuit => circuit.circuit_id);

                  // Pre-populate new bandwidths from network_details
                  const newBWs = {};
                  networkCircuits.forEach(circuit => {
                    if (circuit.circuit_id && circuit.new_bandwidth) {
                      newBWs[circuit.circuit_id] = circuit.new_bandwidth;
                    }
                  });

                  // Set with a slight delay to ensure selectedCircuits are set first
                  setTimeout(() => {
                    console.log("Setting selected circuits from network_details:", circuitIds);
                    setSelectedCircuits(circuitIds);

                    if (Object.keys(newBWs).length > 0) {
                      console.log("Setting new bandwidths from network_details:", newBWs);
                      setNewBandwidths(newBWs);
                    }
                  }, 300);
                }

                // Continue with existing code to get data from financial section as fallback...
              } catch (e) {
                console.error("Error parsing request_details_json:", e);
              }
            }

            // Now that site details are loaded, if we have available_circuit data,
            // set the selected circuits based on the saved data
            if (data.available_circuit) {
              const circuits = data.available_circuit
                .split(',')
                .map(c => c.trim())
                .filter(c => c && c !== "Empty in TMP file");

              console.log("Setting selected circuits from saved data:", circuits);
              // Only set if we have valid circuits
              if (circuits.length > 0) {
                setSelectedCircuits(circuits);
              }
            }

            // Parse and set bandwidth values
            let currentBWs = {};
            let newBWs = {};

            // Try to parse from request_details_json first
            // Add after await handleSiteIdChange(data.site_id); in your loadExistingRequest function
            // This will properly extract circuit details from request_details_json and select them
            // Add this after your handleSiteIdChange call in loadExistingRequest function
            if (data.request_details_json) {
              try {
                const detailsJson = JSON.parse(data.request_details_json);

                // Extract circuit ID from financial section - this is our source of truth
                if (detailsJson.financial?.circuit_details) {
                  const savedCircuitIds = detailsJson.financial.circuit_details.map(circuit => circuit.circuit_id);
                  console.log("Found saved circuits in JSON:", savedCircuitIds);

                  // Set these circuits as selected with a delay to ensure availableCircuits is populated
                  // Replace the code within the setTimeout function in your loadExistingRequest function

                  setTimeout(async () => {
                    if (savedCircuitIds.length > 0) {
                      console.log("Setting selected circuits to:", savedCircuitIds);
                      setSelectedCircuits(savedCircuitIds);

                      // IMPORTANT: Now get current bandwidths from the site details API
                      try {
                        // We already have siteDetails from handleSiteIdChange, but we need to wait
                        // for the circuit selection to be set before setting bandwidths
                        const siteDetails = await ApiService.getSiteDetails(data.site_id);

                        // Extract current bandwidths from site details (API returns providers[].circuits[].bandwidth)
                        const bandwidthMap = {};
                        if (siteDetails && Array.isArray(siteDetails.providers)) {
                          siteDetails.providers.forEach(provider => {
                            (provider.circuits || []).forEach(circuit => {
                              if (circuit.id) {
                                bandwidthMap[circuit.id] = circuit.bandwidth === "Empty in TMP file"
                                  ? "Empty in TMP file"
                                  : (circuit.bandwidth || "Empty in TMP file");
                              }
                            });
                          });
                        }
                        if (Object.keys(bandwidthMap).length > 0) {
                          console.log("Setting bandwidth from site details:", bandwidthMap);
                          setCircuitBandwidths(bandwidthMap);

                          // If we have the new_bandwidth from the saved request, set it too
                          const newBWs = {};

                          // Try to get new bandwidth values from network_details.circuits first (this is where they actually are)
                          if (detailsJson.network_details?.circuits && Array.isArray(detailsJson.network_details.circuits)) {
                            detailsJson.network_details.circuits.forEach(circuit => {
                              if (circuit.circuit_id && circuit.new_bandwidth) {
                                newBWs[circuit.circuit_id] = circuit.new_bandwidth;
                              }
                            });
                            console.log("Found new bandwidths in network_details.circuits:", newBWs);
                          }

                          // If we didn't find any new bandwidths, try the financial section as fallback
                          if (Object.keys(newBWs).length === 0) {
                            savedCircuitIds.forEach(circuitId => {
                              // Try to find this circuit's new bandwidth in the financial data
                              const savedCircuit = detailsJson.financial.circuit_details.find(c => c.circuit_id === circuitId);
                              if (savedCircuit && savedCircuit.new_bandwidth) {
                                newBWs[circuitId] = savedCircuit.new_bandwidth;
                              }
                            });
                            console.log("Found new bandwidths in financial.circuit_details:", newBWs);
                          }

                          if (Object.keys(newBWs).length > 0) {
                            console.log("Setting new bandwidths from saved data:", newBWs);
                            setNewBandwidths(newBWs);
                          } else {
                            console.warn("No new bandwidth values found in saved request");
                          }
                        }
                      } catch (error) {
                        console.error("Error fetching current bandwidths:", error);
                      }
                    }
                  }, 500);
                }
              } catch (e) {
                console.error("Error parsing request_details_json:", e);
              }
            }

            // If we have bandwidth data, set it
            if (Object.keys(currentBWs).length > 0) {
              setCircuitBandwidths(currentBWs);
            }
            if (Object.keys(newBWs).length > 0) {
              setNewBandwidths(newBWs);
            }
          }
        }

        // If we have cost estimate info, try to parse it
        if (data.cost_estimate) {
          try {
            const costValue = parseFloat(data.cost_estimate);
            if (!isNaN(costValue)) {
              setEstimatedCost(prevCost => ({
                ...prevCost,
                total: costValue
              }));
            }
          } catch (e) {
            console.error('Error parsing cost estimate:', e);
          }
        }

      } catch (error) {
        console.error('Error loading request for update:', error);
        setDialogTitle('Error');
        setDialogMessage('Failed to load request details. Please try again.');
        setDialogOpen(true);
      } finally {
        setIsCalculatingCosts(false);
      }
    };

    loadExistingRequest();

  }, [updateId, setValue, userRole.userEmail, location.search]);
  // Add this useEffect after your other useEffects
  useEffect(() => {
    if (selectedCircuits.length > 0) {
      setValue('numberOfLinks', selectedCircuits.length.toString());
      console.log("Updated numberOfLinks to:", selectedCircuits.length);
    }
  }, [selectedCircuits, setValue]);
  // Add this useEffect AFTER your existing useEffects (around line 1108)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestType = params.get('type');

    // If this is an AGN Firewall update, set the form accordingly
    if (updateId && requestType === 'agn_firewall') {
      setValue('odmType', 'AGN Managed-Firewall Decommissioning');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }

    if (updateId && requestType === 'agn_webex') {
      setValue('odmType', 'AGN Webex Decommissioning Request');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }

    if (updateId && requestType === 'agn_ipt') {
      setValue('odmType', 'AGN IPT Decommissioning Request');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }

    if (updateId && requestType === 'circuit_order') {
      setValue('odmType', 'Circuit Ordering');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }

    if (updateId && requestType === 'new_site') {
      setValue('odmType', 'New Site Ordering');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }

    if (updateId && requestType === 'site_expansion') {
      setValue('odmType', 'Site Expansion');
      setShowAdditionalFields(true);
      setIsUpdateMode(true);
    }
  }, [updateId, location.search, setValue]);

  // Load external demand data when it arrives
  useEffect(() => {
    if (demandData && isExternal) {
      console.log('Loading external demand data:', grmDemandNumber);

      // Set form type first
      if (demandData.request_type) {
        const typeMap = {
          'bandwidth_change': 'Bandwidth Upgrade/Downgrade',
          'agn_managed_firewall': 'AGN Managed-Firewall Decommissioning',
          'agn_webex_decommissioning': 'AGN Webex Decommissioning Request',
          'agn_ipt_decommissioning': 'AGN IPT Decommissioning Request',
          'circuit_ordering': 'Circuit Ordering',
          'agn_circuit_ordering': 'Circuit Ordering',
          'new_site_ordering': 'New Site Ordering',
          'site_expansion': 'Site Expansion',
        };
        const mappedType = typeMap[demandData.request_type] || demandData.request_type;
        setValue('odmType', mappedType);
        setShowAdditionalFields(true);
      }

      // Map snake_case backend fields to camelCase form field names
      setValue('grmDemandNumber', demandData.grm_demand_number || '');
      setValue('odmTitle', demandData.odm_title || '');
      setValue('costCentre', demandData.cost_centre || '');
      setValue('debtor', demandData.debtor || '');
      setValue('descriptionOfOdmRequest', demandData.description_of_odm_request || '');
      if (demandData.oe_name) setValue('oeName', demandData.oe_name);

      console.log('External demand data loaded successfully');
    }
  }, [demandData, isExternal, grmDemandNumber, setValue]);

  // The 5 GRM-provided fields that must be read-only when the user arrives via
  // GRM redirect URL (?grm_demand_number=...&request_type=...)
  const GRM_LOCKED_FIELDS = [
    'grmDemandNumber',
    'odmTitle',
    'costCentre',
    'debtor',
    'descriptionOfOdmRequest',
    'oeName',
  ];

  const isFieldReadOnly = (fieldName) => {
    // All 5 GRM fields are locked when the user arrives via the redirect URL
    if (isExternal && GRM_LOCKED_FIELDS.includes(fieldName)) {
      return true;
    }

    // GRM Number is also locked in update mode (cannot change after submission)
    if (isUpdateMode && fieldName === 'grmDemandNumber') {
      return true;
    }

    // City and country are always read-only (auto-filled from site lookup)
    const alwaysReadOnly = ['city', 'country'];
    return alwaysReadOnly.includes(fieldName);
  };

   useEffect(() => {
    const params = new URLSearchParams(location.search);
    const updateIdParam = params.get('updateId');
    const requestTypeParam = params.get('type');

    if (updateIdParam) {
      setUpdateId(updateIdParam);
    }

    if (requestTypeParam === 'bandwidth_change') {
      setValue('odmType', 'Bandwidth Upgrade/Downgrade');
      setShowAdditionalFields(true);
    }

    if (requestTypeParam === 'agn_webex') {
      setValue('odmType', 'AGN Webex Decommissioning Request');
      setShowAdditionalFields(true);
    }

    if (requestTypeParam === 'agn_ipt') {
      setValue('odmType', 'AGN IPT Decommissioning Request');
      setShowAdditionalFields(true);
    }

    if (requestTypeParam === 'circuit_order') {
      setValue('odmType', 'Circuit Ordering');
      setShowAdditionalFields(true);
    }

    if (requestTypeParam === 'new_site') {
      setValue('odmType', 'New Site Ordering');
      setShowAdditionalFields(true);
    }

    if (requestTypeParam === 'site_expansion') {
      setValue('odmType', 'Site Expansion');
      setShowAdditionalFields(true);
    }
  }, [location.search, setValue]);


  return (
    <Layout>
      <Box sx={{
        maxWidth: 800,
        mx: 'auto',
        p: 3,
        background: '#fff',
        borderRadius: 2,
        boxShadow: 3,
        "& .MuiPaper-root": {
          borderRadius: 1,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          transition: "box-shadow 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
          }
        },
        "& .MuiTextField-root": {
          transition: "transform 0.2s ease",
          "&:focus-within": {
            transform: "translateY(-2px)",
          }
        },
        // Simplified styling for h6 headers - removed the blue underline
        "& .MuiTypography-h6": {
          mb: 2,
          fontWeight: 600
          // Removed the position:relative and &:after pseudo-element that created the blue line
        }
      }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', color: '#003781' }}>
          {isUpdateMode ? "Update AGN Demand Request" : "Submit New AGN Demand Request"}
        </Typography>

        {/* External Demand Loading State */}
        {externalLoading && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <CircularProgress />
            <Box sx={{ mt: 2 }}>Loading demand data from GRM Portal...</Box>
          </Box>
        )}

        {/* External Demand — Demand Not Found */}
        {isExternal && externalError && externalError.code === 'NOT_FOUND' && (
          <Alert
            severity="error"
            sx={{ mb: 3, border: '1px solid #d32f2f' }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => window.location.reload()}
                sx={{ fontWeight: 600 }}
              >
                Retry
              </Button>
            }
          >
            <AlertTitle>GRM Demand Not Found</AlertTitle>
            Demand number <strong>{grmDemandNumber}</strong> was not found in the system.
            The GRM request may not have been processed yet. Please wait a moment and click
            <strong> Retry</strong>, or contact the GRM Portal team if the issue persists.
          </Alert>
        )}

        {/* External Demand — Already Submitted */}
        {isExternal && externalError && externalError.code === 'ALREADY_SUBMITTED' && (
          <Alert severity="warning" sx={{ mb: 3, border: '1px solid #ed6c02' }}>
            <AlertTitle>Request Already Submitted</AlertTitle>
            Demand number <strong>{grmDemandNumber}</strong> has already been submitted as an ODM
            request. If you believe this is a mistake, please contact the ODM Portal team.
          </Alert>
        )}

        {/* External Demand — Request Type Mismatch */}
        {isExternal && externalError && externalError.code === 'TYPE_MISMATCH' && (
          <Alert severity="error" sx={{ mb: 3, border: '1px solid #d32f2f' }}>
            <AlertTitle>Incorrect Request Type</AlertTitle>
            {externalError.message}
          </Alert>
        )}

        {/* External Demand — Other Errors */}
        {isExternal && externalError && !['NOT_FOUND', 'TYPE_MISMATCH', 'ALREADY_SUBMITTED'].includes(externalError.code) && (
          <Alert severity="error" sx={{ mb: 3, border: '1px solid #d32f2f' }}>
            <AlertTitle>Failed to Load Demand Data</AlertTitle>
            Unable to load demand data for <strong>{grmDemandNumber}</strong>.{' '}
            {externalError.message || 'An unexpected error occurred.'} Please refresh
            the page or contact support if the problem continues.
          </Alert>
        )}

        {/* External Demand — Success / Info Banner */}
        {isExternal && !externalLoading && !externalError && demandData && (
          <Alert severity="info" sx={{ mb: 3, border: '1px solid #0288d1' }}>
            <AlertTitle>Pre-filled from GRM Portal</AlertTitle>
            The following fields have been pre-filled from GRM Portal and{' '}
            <strong>cannot be edited</strong>: GRM Number, ODM Title, Cost Centre,
            Debtor, Description. Please complete the remaining fields and submit.
            <Box sx={{ mt: 0.5 }}>
              <strong>GRM Number:</strong> {grmDemandNumber}
            </Box>
          </Alert>
        )}

        <form onSubmit={handleSubmit(onSubmit, onFormInvalid)}>
          {/* Basic Information Section */}
          <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
              Basic Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Controller
                  name="odmTitle"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'ODM Title is required' }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="ODM Title *"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      disabled={isFieldReadOnly('odmTitle')}
                      InputProps={{ readOnly: isFieldReadOnly('odmTitle') }}
                      sx={{
                        ...(isFieldReadOnly('odmTitle') && {
                          '& .Mui-disabled': {
                            backgroundColor: '#f5f5f5',
                            WebkitTextFillColor: 'rgba(0,0,0,0.7)',
                          },
                        }),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="odmType"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'ODM Type is required' }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      select
                      label="ODM Type *"
                      disabled={isUpdateMode}
                      sx={{
                        backgroundColor: isUpdateMode ? '#f5f5f5' : 'inherit', // Gray out when disabled
                      }}
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      onChange={(e) => {
                        field.onChange(e);
                        handleRequestTypeChange(e.target.value);
                      }}
                      style={{ minWidth: '200px' }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: { maxHeight: 300, width: 'auto' }
                          }
                        }
                      }}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="Bandwidth Upgrade/Downgrade">Bandwidth Upgrade/Downgrade</MenuItem>
                      <MenuItem value="AGN Managed-Firewall Decommissioning">AGN Managed-Firewall Decommissioning</MenuItem>
                      <MenuItem value="AGN Webex Decommissioning Request">AGN Webex Decommissioning Request</MenuItem>
                      <MenuItem value="AGN IPT Decommissioning Request">AGN IPT Decommissioning Request</MenuItem>
                      <MenuItem value="Circuit Ordering">Circuit Ordering</MenuItem>
                      <MenuItem value="New Site Ordering">New Site Ordering</MenuItem>
                      <MenuItem value="Site Expansion">Site Expansion</MenuItem>
                    </TextField>
                  )}
                />
              </Grid>

              {/* GRM No — shown once a request type is selected */}
              {showAdditionalFields && (
                <Grid item xs={12} sm={requestType === 'New Site Ordering' ? 6 : 12}>
                  <Controller
                    name="grmDemandNumber"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: 'GRM No is required',
                      pattern: {
                        value: /^[A-Za-z]{4}[0-9]{7}$/,
                        message: 'GRM No must be 4 letters followed by 7 numbers (e.g., DMND1234567)'
                      }
                    }}
                    render={({ field, fieldState }) => (
                      <TextField
                        {...field}
                        label="GRM No *"
                        fullWidth
                        placeholder="DMND1234567"
                        error={!!fieldState.error || !!grmNumberError || !!grmFormatError}
                        helperText={
                          fieldState.error?.message ||
                          grmNumberError ||
                          grmFormatError ||
                          "Format: 4 letters followed by 7 numbers (e.g., DMND1234567)"
                        }
                        disabled={isFieldReadOnly('grmDemandNumber')}
                        InputProps={{ readOnly: isFieldReadOnly('grmDemandNumber') }}
                        sx={{
                          "& .Mui-disabled": {
                            backgroundColor: "#f5f5f5",
                            WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                          }
                        }}
                        onBlur={() => {
                          if (!isUpdateMode && field.value) {
                            validateGrmNumber(field.value);
                          }
                        }}
                        onChange={(e) => {
                          field.onChange(e);
                          if (!isUpdateMode) {
                            setIsGrmTyping(true);
                            setGrmFormatError(null);
                            setGrmNumberError(null);
                            const value = e.target.value.toUpperCase();
                            if (value !== e.target.value) {
                              e.target.value = value;
                              field.onChange(e);
                            }
                            const grmRegex = /^[A-Za-z]{4}[0-9]{7}$/;
                            if (value && !grmRegex.test(value)) {
                              setGrmFormatError('Invalid format. Must be 4 letters followed by 7 numbers.');
                              setIsGrmNumberValid(false);
                            } else {
                              setGrmFormatError(null);
                              setIsGrmNumberValid(true);
                            }
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
              )}

              {/* Primary Location ID — New Site Ordering only */}
              {showAdditionalFields && requestType === 'New Site Ordering' && (
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="primaryLocationId"
                    control={control}
                    defaultValue=""
                    rules={{ required: 'Primary Location ID is required' }}
                    render={({ field, fieldState }) => (
                      <TextField
                        {...field}
                        label={
                          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                            Primary Location ID *
                            <Tooltip
                              arrow
                              placement="right"
                              title={
                                <Box component="span" sx={{ display: 'block' }}>
                                  From ServiceNow Service Catalog &gt; SIM Services
                                </Box>
                              }
                            >
                              <HelpOutlineIcon
                                fontSize="small"
                                sx={{ ml: 0.5, color: 'text.secondary', fontSize: '16px', cursor: 'help' }}
                              />
                            </Tooltip>
                          </Box>
                        }
                        placeholder="e.g. LOC-00123456"
                        fullWidth
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message || 'From ServiceNow Service Catalog → SIM Services'}
                        disabled={isFieldReadOnly('primaryLocationId')}
                        InputProps={{ readOnly: isFieldReadOnly('primaryLocationId') }}
                        sx={{
                          ...(isFieldReadOnly('primaryLocationId') && {
                            '& .Mui-disabled': {
                              backgroundColor: '#f5f5f5',
                              WebkitTextFillColor: 'rgba(0,0,0,0.7)',
                            },
                          }),
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </Paper>

          {showAdditionalFields && (
            <>
              {requestType === 'Circuit Ordering' ? (
                <CircuitOrderForm
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  getValues={getValues}
                  trigger={trigger}
                  handleSubmit={handleSubmit}
                  userRole={userRole}
                  isUpdateMode={isUpdateMode}
                  updateId={updateId}
                  externalDemandData={isExternal ? demandData : null}
                />
              ) : requestType === 'New Site Ordering' ||
                (() => {
                  const urlParams = new URLSearchParams(location.search);
                  return urlParams.get('type') === 'new_site';
                })() ? (
                <NewSiteOrderingForm
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  getValues={getValues}
                  trigger={trigger}
                  handleSubmit={handleSubmit}
                  userRole={userRole}
                  isUpdateMode={isUpdateMode}
                  updateId={updateId}
                  externalDemandData={isExternal ? demandData : null}
                />
              ) : requestType === 'Site Expansion' ||
                (() => {
                  const urlParams = new URLSearchParams(location.search);
                  return urlParams.get('type') === 'site_expansion';
                })() ? (
                <SiteExpansionForm
                  watch={watch}
                  userRole={userRole}
                  isUpdateMode={isUpdateMode}
                  updateId={updateId}
                  externalDemandData={isExternal ? demandData : null}
                />
              ) : requestType === 'AGN Managed-Firewall Decommissioning' ||
                (() => {
                  const urlParams = new URLSearchParams(location.search);
                  return urlParams.get('type') === 'agn_firewall';
                })() ? (
                // Show AGN Firewall Form
                <Suspense fallback={<div>Loading AGN Firewall form...</div>}>
                  <AGNFirewallForm
                    control={control}
                    watch={watch}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    trigger={trigger}
                    handleSubmit={handleSubmit}
                    userRole={userRole}
                    isUpdateMode={isUpdateMode}
                    updateId={updateId}
                  />
                </Suspense>
              ) : requestType === 'AGN Webex Decommissioning Request' ||
                (() => {
                  const urlParams = new URLSearchParams(location.search);
                  return urlParams.get('type') === 'agn_webex';
                })() ? (
                <AGNWebexDecommissioningForm
                  control={control}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    trigger={trigger}
                    handleSubmit={handleSubmit}
                    userRole={userRole}
                    isUpdateMode={isUpdateMode}
                    updateId={updateId}
                />
              ) : requestType === 'AGN IPT Decommissioning Request' ||
                (() => {
                  const urlParams = new URLSearchParams(location.search);
                  return urlParams.get('type') === 'agn_ipt';
                })() ? (
                <AGNIPTDecommissioningForm
                  control={control}
                  watch={watch}
                  setValue={setValue}
                  getValues={getValues}
                  trigger={trigger}
                  handleSubmit={handleSubmit}
                  userRole={userRole}
                  isUpdateMode={isUpdateMode}
                  updateId={updateId}
                />
              ) : (

                  <>
                    {/* Details of Existing Site */}
                    <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
                        Details of Existing Site
                      </Typography>
                      <Grid container spacing={3}> {/* Increase spacing from 2 to 3 */}
                        {/* First row - core identifiers */}
                        <Grid item xs={6}>
                          <Controller
                            name="oeName"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'OE Name is required',
                              pattern: {
                                value: /^[A-Za-z\s]{6,40}$/,
                                message: 'OE Name must be 6-40 alphabetic characters'
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="OE Name *"
                                fullWidth
                                placeholder="Allianz Technology"
                                error={!!fieldState.error || !!oeNameError}
                                helperText={
                                  fieldState.error?.message ||
                                  oeNameError ||
                                  (isOeNameTyping ? "Continue typing..." : "Enter a name (e.g., Allianz Technology)")
                                }
                                onBlur={() => {
                                  setIsOeNameTyping(false);
                                  // Validate the complete field on blur
                                  const value = field.value;
                                  if (value) {
                                    if (!/^[A-Za-z\s]{6,40}$/.test(value)) {
                                      setOeNameError('OE Name must be 6-40 alphabetic characters');
                                      setIsOeNameValid(false);
                                    } else {
                                      setOeNameError(null);
                                      setIsOeNameValid(true);
                                    }
                                  } else {
                                    // Field is empty
                                    setOeNameError('OE Name is required');
                                    setIsOeNameValid(false);
                                  }
                                }}
                                onChange={(e) => {
                                  // Allow only letters and spaces
                                  const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                  field.onChange(value);

                                  // Show typing indicator
                                  setIsOeNameTyping(true);

                                  // Real-time validation
                                  if (value) {
                                    if (value.length < 6) {
                                      setOeNameError(`OE Name must be at least 6 characters (currently ${value.length})`);
                                      setIsOeNameValid(false);
                                    } else if (value.length > 40) {
                                      setOeNameError('OE Name cannot exceed 40 characters');
                                      setIsOeNameValid(false);
                                    } else if (!/^[A-Za-z\s]+$/.test(value)) {
                                      setOeNameError('OE Name can only contain letters and spaces');
                                      setIsOeNameValid(false);
                                    } else {
                                      setOeNameError(null);
                                      setIsOeNameValid(true);
                                    }
                                  } else {
                                    // Field is empty
                                    setOeNameError('OE Name is required');
                                    setIsOeNameValid(false);
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="siteId"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Site ID is required' }}
                            render={({ field, fieldState }) => (
                              <ExcelDropdown
                                value={field.value}
                                onChange={(newValue) => handleSiteIdChange(newValue)}
                                error={!!fieldState.error || !!siteIdError || (siteDetailsError && siteDetailsError.includes("No active circuits"))}
                                helperText={
                                  fieldState.error?.message ||
                                    siteIdError ||
                                    (siteDetailsError && siteDetailsError.includes("No active circuits")) ?
                                    siteDetailsError :
                                    "Select a site ID from the dropdown"
                                }
                                disabled={isSaving || isSubmitting}
                                label={excelFieldConfig.siteId.label}
                                placeholder={excelFieldConfig.siteId.placeholder}
                                columnName={excelFieldConfig.siteId.columnName}
                              />
                            )}
                          />
                        </Grid>

                        {/* Loading indicator - preserve exactly as is */}
                        {siteDetailsLoading && (
                          <Grid item xs={12}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <CircularProgress size={20} />
                              <Typography variant="body2" color="textSecondary">
                                Loading site details...
                              </Typography>
                            </Box>
                          </Grid>
                        )}

                        {/* Error message - preserve exactly as is */}
                        {siteDetailsError && (
                          <Grid item xs={12}>
                            <Typography variant="body2" color="error">
                              {siteDetailsError}
                            </Typography>
                          </Grid>
                        )}

                        {/* Site address - full width for better readability */}
                        <Grid item xs={12}>
                          <Controller
                            name="siteAddress"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Site Address"
                                fullWidth
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="siteType"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Site Type is required' }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                select
                                label="Site Type *"
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message || "Please select the site type"}
                                SelectProps={{
                                  MenuProps: {
                                    PaperProps: { style: { maxHeight: 300 } }
                                  }
                                }}
                              >
                                <MenuItem value="">Select Site Type</MenuItem>
                                <MenuItem value="Normal Site">Normal Site</MenuItem>
                                <MenuItem value="Call Center">Call Center</MenuItem>
                                <MenuItem value="Data Center">Data Center</MenuItem>
                              </TextField>
                            )}
                          />
                        </Grid>


                        {/* Location info - city and country */}
                        <Grid item xs={6}>
                          <Controller
                            name="city"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="City"
                                fullWidth
                                disabled={true}
                                InputProps={{
                                  readOnly: true
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="country"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Country"
                                fullWidth
                                disabled={true}
                                InputProps={{
                                  readOnly: true
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>

                        {/* Financial info */}
                        <Grid item xs={6}>
                          <Controller
                            name="costCentre"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'Cost Centre is required',
                              pattern: {
                                value: /^\d{10}$/,
                                message: 'Cost Centre must be exactly 10 digits'
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Cost Centre *"
                                fullWidth
                                placeholder="1234567890"
                                inputProps={{
                                  inputMode: isFieldReadOnly('costCentre') ? undefined : 'numeric',
                                  maxLength: 10
                                }}
                                disabled={isFieldReadOnly('costCentre')}
                                InputProps={{ readOnly: isFieldReadOnly('costCentre') }}
                                error={!isFieldReadOnly('costCentre') && (!!fieldState.error || !!costCentreError)}
                                helperText={
                                  isFieldReadOnly('costCentre')
                                    ? undefined
                                    : (fieldState.error?.message ||
                                       costCentreError ||
                                       (isCostCentreTyping ? "Continue typing..." : "Enter a 10-digit numeric Cost Centre"))
                                }
                                onChange={(e) => {
                                  if (isFieldReadOnly('costCentre')) return;
                                  const value = e.target.value;

                                  // Only allow digits, strip anything else
                                  if (value && !/^\d*$/.test(value)) {
                                    e.target.value = value.replace(/\D/g, '');
                                  }

                                  field.onChange(e);
                                  setIsCostCentreTyping(true);

                                  // Additional validation for exactly 10 digits
                                  if (value && !/^\d+$/.test(value)) {
                                    setCostCentreError("Cost Centre must contain only digits");
                                    setIsCostCentreValid(false);
                                  } else if (value && value.length < 10) {
                                    setCostCentreError(`Cost Centre must be exactly 10 digits (${value.length}/10)`);
                                    setIsCostCentreValid(false);
                                  } else if (value && value.length > 10) {
                                    setCostCentreError("Cost Centre cannot exceed 10 digits");
                                    setIsCostCentreValid(false);
                                  } else if (value && value.length === 10) {
                                    setCostCentreError(null);
                                    setIsCostCentreValid(true);
                                  } else {
                                    setCostCentreError(null);
                                  }

                                  setTimeout(() => setIsCostCentreTyping(false), 1500);
                                }}
                                onKeyPress={(e) => {
                                  if (isFieldReadOnly('costCentre')) return;
                                  // Prevent typing non-digit characters
                                  if (!/[\d]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={() => {
                                  if (isFieldReadOnly('costCentre')) return;
                                  field.onBlur();
                                  setIsCostCentreTyping(false);
                                }}
                                sx={{
                                  ...(isFieldReadOnly('costCentre') && {
                                    '& .Mui-disabled': {
                                      backgroundColor: '#f5f5f5',
                                      WebkitTextFillColor: 'rgba(0,0,0,0.7)',
                                    },
                                  }),
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="debtor"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'Debtor is required',
                              pattern: {
                                value: /^\d{10}$/,
                                message: 'Debtor must be exactly 10 digits'
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Debtor *"
                                fullWidth
                                placeholder="1234567890"
                                disabled={isFieldReadOnly('debtor')}
                                InputProps={{ readOnly: isFieldReadOnly('debtor') }}
                                error={!isFieldReadOnly('debtor') && (!!fieldState.error || !!debtorError)}
                                helperText={
                                  isFieldReadOnly('debtor')
                                    ? undefined
                                    : (fieldState.error?.message ||
                                       debtorError ||
                                       (isDebtorTyping ? "Continue typing..." : "Enter a 10-digit number"))
                                }
                                inputProps={{
                                  inputMode: isFieldReadOnly('debtor') ? undefined : 'numeric',
                                  maxLength: 10
                                }}
                                onBlur={() => {
                                  if (isFieldReadOnly('debtor')) return;
                                  setIsDebtorTyping(false);
                                  // Validate the complete field on blur
                                  const value = field.value;
                                  if (value) {
                                    if (!/^\d{10}$/.test(value)) {
                                      setDebtorError('Debtor must be exactly 10 digits');
                                      setIsDebtorValid(false);
                                    } else {
                                      setDebtorError(null);
                                      setIsDebtorValid(true);
                                    }
                                  } else {
                                    setDebtorError('Debtor is required');
                                    setIsDebtorValid(false);
                                  }
                                }}
                                onChange={(e) => {
                                  if (isFieldReadOnly('debtor')) return;
                                  // Allow only digits
                                  const value = e.target.value.replace(/\D/g, '');

                                  // Limit to 10 digits
                                  const truncatedValue = value.slice(0, 10);
                                  field.onChange(truncatedValue);

                                  // Show typing indicator
                                  setIsDebtorTyping(true);

                                  // Real-time validation
                                  if (value) {
                                    if (!/^\d+$/.test(value)) {
                                      setDebtorError('Debtor must contain only digits');
                                      setIsDebtorValid(false);
                                    } else if (value.length < 10) {
                                      setDebtorError(`Debtor must be 10 digits (currently ${value.length})`);
                                      setIsDebtorValid(false);
                                    } else if (value.length > 10) {
                                      setDebtorError('Debtor cannot exceed 10 digits');
                                      setIsDebtorValid(false);
                                    } else {
                                      setDebtorError(null);
                                      setIsDebtorValid(true);
                                    }
                                  } else {
                                    setDebtorError(null);
                                    setIsDebtorValid(false);
                                  }
                                }}
                                sx={{
                                  ...(isFieldReadOnly('debtor') && {
                                    '& .Mui-disabled': {
                                      backgroundColor: '#f5f5f5',
                                      WebkitTextFillColor: 'rgba(0,0,0,0.7)',
                                    },
                                  }),
                                }}
                              />
                            )}
                          />
                        </Grid>

                        {/* Provider information */}
                        <Grid item xs={6}>
                          <Controller
                            name="currentProvider"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Current Provider is required' }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Current Provider *"
                                fullWidth
                                select
                                required={true}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                disabled={providerOptions.length === 0 || providerOptions[0].value === "Empty in TMP file"}
                                onChange={(e) => {
                                  // If only one provider and it's mandatory, prevent changing to empty
                                  if (providerOptions.length === 1 && providerOptions[0].mandatory && !e.target.value) {
                                    return;
                                  }
                                  field.onChange(e);
                                  handleProviderChange(e.target.value);
                                }}
                                SelectProps={{
                                  native: false,
                                  MenuProps: {
                                    PaperProps: {
                                      style: { maxHeight: 300, width: 'auto' }
                                    }
                                  }
                                }}
                                style={{
                                  minWidth: '200px',
                                  width: '100%'
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                  },
                                  "& .MuiSelect-select": {
                                    width: '100%'
                                  },
                                  "& .MuiInputBase-root": {
                                    width: '100%'
                                  },
                                  width: '100%'
                                }}
                              >
                                {/* Only show Select option if there's more than one provider and they're not mandatory */}
                                {!(providerOptions.length === 1 && providerOptions[0].mandatory) && (
                                  <MenuItem value="">Select Provider</MenuItem>
                                )}
                                {providerOptions.map((option) => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.value}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          {selectedProvider && (
                            <Grid item xs={12} sx={{ mb: 2 }}>
                              <CircuitSelection
                                circuits={availableCircuits}
                                selectedCircuits={selectedCircuits}
                                onChange={handleCircuitSelection}
                                error={circuitError}
                              />
                            </Grid>
                          )}
                        </Grid>

                        {/* Hidden Number of Links field that's still included in form data */}
                        <Controller
                          name="numberOfLinks"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: 'Number of Links is required',
                            validate: {
                              isNumber: value => !isNaN(value) && Number(value) > 0 || 'Please enter a valid number greater than 0'
                            }
                          }}
                          render={({ field }) => (
                            <input
                              type="hidden"
                              {...field}
                              value={selectedCircuits.length > 0 ? selectedCircuits.length.toString() : field.value}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                              }}
                            />
                          )}
                        />

                        {/* Bandwidth Configuration Section */}
                        {selectedCircuits.length > 0 && (
                          <Grid item xs={12} sx={{ mt: 3 }}>
                            <Typography
                              variant="h6"
                              sx={{
                                mb: 2,
                                fontWeight: 500,
                                color: '#003781',
                                fontSize: '1.25rem',
                                borderBottom: '1px solid #eaeaea',
                                paddingBottom: '8px'
                              }}
                            >
                              Bandwidth Configuration
                            </Typography>

                            <Box sx={{
                              borderRadius: 1,
                              border: '1px solid #e0e0e0',
                              overflow: 'hidden',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                            }}>
                              {selectedCircuits
                                .filter(circuit => circuit && circuit !== "Empty in TMP file")
                                .map((circuit, index, filteredCircuits) => (
                                  <Box
                                    key={circuit}
                                    sx={{
                                      p: 2.5,
                                      mb: index === filteredCircuits.length - 1 ? 0 : 2,
                                      borderBottom: index === filteredCircuits.length - 1 ? 'none' : '1px solid #eaeaea',
                                      backgroundColor: 'white',
                                      transition: 'background-color 0.3s ease',
                                      '&:hover': {
                                        backgroundColor: '#fcfcfc'
                                      }
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      gutterBottom
                                      sx={{
                                        color: '#003781',
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <Box component="span" sx={{ mr: 1 }}>Circuit:</Box>
                                      <Box component="span" sx={{ fontWeight: 400 }}>{circuit}</Box>
                                    </Typography>

                                    <Grid container spacing={2.5} sx={{ mt: 0.5 }}>
                                      <Grid item xs={6}>
                                        <TextField
                                          label="Current Bandwidth"
                                          value={
                                            circuitBandwidths[circuit] === "Empty in TMP file"
                                              ? "Empty in TMP file"
                                              : circuitBandwidths[circuit]
                                                ? `${circuitBandwidths[circuit]} Mbps`
                                                : 'Not specified'
                                          }
                                          InputProps={{
                                            readOnly: true
                                          }}
                                          fullWidth
                                          disabled
                                          sx={{
                                            "& .Mui-disabled": {
                                              backgroundColor: "#f5f5f5",
                                              WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                            }
                                          }}
                                        />
                                      </Grid>

                                      <Grid item xs={6}>
                                      <TextField
  label="New Bandwidth *"
  value={newBandwidths[circuit] || ''}
  onChange={(e) => handleNewBandwidthChange(circuit, e.target.value)}
  onBlur={() => handleBandwidthBlur(circuit)}
  placeholder="e.g., 100"
  fullWidth
  required
  // 🔧 CHANGE: Only show as error if it's NOT a warning
  error={!!bandwidthErrors[circuit] && !bandwidthErrors[circuit].startsWith('⚠️')}
  helperText={bandwidthErrors[circuit] ? (
    <span style={{ 
      // 🔧 CHANGE: Blue for warnings (⚠️), red for errors
      color: bandwidthErrors[circuit].startsWith('⚠️') ? '#1976d2' : '#d32f2f' 
    }}>
      {bandwidthErrors[circuit]}
      {suggestedBandwidths[circuit] &&
        ` Suggested: ${suggestedBandwidths[circuit]} Mbps`}
    </span>
  ) : (
    !newBandwidths[circuit] ? "Required" : ""
  )}
  InputProps={{
    endAdornment: <InputAdornment position="end">Mbps</InputAdornment>
  }}
  inputProps={{
    pattern: '[0-9]*',
    inputMode: 'numeric'
  }}
/>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                ))}
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Paper>

                    {/* Technical Details */}
                    <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
                        Technical Details
                      </Typography>
                      <Grid container spacing={3}> {/* Increase spacing from 2 to 3 */}
                        {/* Link Type and Router Model in first row */}
                        <Grid item xs={6}>
                          <Controller
                            name="linkType"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Link Type"
                                fullWidth
                                disabled={true}
                                InputProps={{
                                  readOnly: true
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: field.value === "Empty in TMP file"
                                      ? "rgba(0, 0, 0, 0.5)" // Slightly lighter for "Empty" text
                                      : 'rgba(0, 0, 0, 0.7)',
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="routerModel"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Router Model"
                                fullWidth
                                disabled={true}
                                InputProps={{
                                  readOnly: true
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>

                        {/* Installation date in its own row */}
                        <Grid item xs={6}>
                          <Controller
                            name="desiredDateOfInstallation"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'Desired Date of Installation is required',
                              validate: {
                                futureDate: value => {
                                  const today = new Date();
                                  const selectedDate = new Date(value);

                                  // Set hours to 0 for both dates for proper day comparison
                                  today.setHours(0, 0, 0, 0);
                                  selectedDate.setHours(0, 0, 0, 0);

                                  // Calculate minimum date (60 days from today)
                                  const minDate = new Date(today);
                                  minDate.setDate(today.getDate() + 60);

                                  if (selectedDate < minDate) {
                                    return `Please select a date at least 60 days in the future (${minDate.toLocaleDateString()})`;
                                  }
                                  return true;
                                }
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Desired Date of Installation *"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                error={!!fieldState.error || !!dateError}
                                helperText={fieldState.error?.message || dateError || "Please select a date at least 60 days in the future"}
                                inputProps={{
                                  min: (() => {
                                    const minDate = new Date();
                                    minDate.setDate(minDate.getDate() + 60);
                                    return minDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
                                  })()
                                }}
                                onChange={(e) => {
                                  field.onChange(e);

                                  // Complete real-time validation for date
                                  const value = e.target.value;
                                  if (value) {
                                    const today = new Date();
                                    const selectedDate = new Date(value);

                                    // Reset hours for proper day comparison
                                    today.setHours(0, 0, 0, 0);
                                    selectedDate.setHours(0, 0, 0, 0);

                                    // Calculate minimum date (60 days from today)
                                    const minDate = new Date(today);
                                    minDate.setDate(today.getDate() + 60);

                                    if (selectedDate < minDate) {
                                      // Format the minDate for display
                                      const formattedMinDate = minDate.toLocaleDateString();
                                      setDateError(`Date must be at least 60 days in the future (${formattedMinDate})`);
                                      setIsDateValid(false);
                                    } else {
                                      setDateError(null);
                                      setIsDateValid(true);
                                    }
                                  } else {
                                    setDateError("Desired Date of Installation is required");
                                    setIsDateValid(false);
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* Request Description */}
                    <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
                        Request Description
                      </Typography>
                      <Controller
                        name="descriptionOfOdmRequest"
                        control={control}
                        defaultValue=""
                        rules={{ required: 'Description is required' }}
                        render={({ field, fieldState }) => (
                          <TextField
                            {...field}
                            label="Description of ODM Request *"
                            multiline
                            rows={4}
                            fullWidth
                            disabled={isFieldReadOnly('descriptionOfOdmRequest')}
                            InputProps={{ readOnly: isFieldReadOnly('descriptionOfOdmRequest') }}
                            error={!isFieldReadOnly('descriptionOfOdmRequest') && !!fieldState.error}
                            helperText={isFieldReadOnly('descriptionOfOdmRequest') ? undefined : fieldState.error?.message}
                            variant="outlined"
                            sx={{
                              mb: 2,
                              width: '100%',
                              '& .MuiOutlinedInput-root': { width: '100%' },
                              ...(isFieldReadOnly('descriptionOfOdmRequest') && {
                                '& .Mui-disabled': {
                                  backgroundColor: '#f5f5f5',
                                  WebkitTextFillColor: 'rgba(0,0,0,0.7)',
                                },
                              }),
                            }}
                          />
                        )}
                      />
                    </Paper>

                    {/* Business Reasons */}
                    <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
                        Business Reasons
                      </Typography>
                      <Controller
                        name="businessReasons"
                        control={control}
                        defaultValue=""
                        rules={{ required: 'Business Reasons is required' }}  // Added required validation
                        render={({ field, fieldState }) => (  // Added fieldState parameter
                          <TextField
                            {...field}
                            label="Business Reasons *"  // Added asterisk to indicate required field
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            error={!!fieldState.error}  // Added error indication
                            helperText={fieldState.error?.message}  // Added error message display
                            sx={{
                              mb: 2,
                              width: '100%',
                              '& .MuiOutlinedInput-root': {
                                width: '100%'
                              }
                            }}
                          />
                        )}
                      />
                    </Paper>

                    {/* Customer Contact */}
                    <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ color: '#003781' }}>
                        Customer Contact
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Controller
                            name="customerName"
                            control={control}
                            defaultValue=""
                            rules={{ required: 'Customer Name is required' }}  // Added required validation
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Name *"
                                fullWidth
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="customerContactMail"
                            control={control}
                            defaultValue={userRole.userEmail || ""}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Email *"
                                type="email"
                                fullWidth
                                disabled={true}  // Disabled since it's from SSO
                                InputProps={{
                                  readOnly: true
                                }}
                                sx={{
                                  "& .Mui-disabled": {
                                    backgroundColor: "#f5f5f5",
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.7)',
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Controller
                            name="customerContactPhone"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'Customer Contact Phone is required',
                              validate: (value) => {
                                const error = validatePhoneNumber(value);
                                return error ? error : true;
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Customer Contact Phone *"
                                fullWidth
                                placeholder="+XX (XXX) XXX-XXXX"
                                error={!!fieldState.error || !!customerPhoneError}
                                helperText={
                                  fieldState.error?.message ||
                                  customerPhoneError ||
                                  (isCustomerPhoneTyping ? "Continue typing..." : "Format: +XX (XXX) XXX-XXXX")
                                }
                                onChange={(e) => {
                                  field.onChange(e);
                                  setIsCustomerPhoneTyping(true);

                                  // Perform validation
                                  const error = validatePhoneNumber(e.target.value);
                                  setCustomerPhoneError(error);
                                  setIsCustomerPhoneValid(!error);
                                }}
                                onBlur={() => {
                                  field.onBlur();
                                  setIsCustomerPhoneTyping(false);

                                  // Check if empty on blur
                                  if (!field.value) {
                                    setCustomerPhoneError('Customer Contact Phone is required');
                                    setIsCustomerPhoneValid(false);
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Controller
                            name="siteTechnicalUserEmail"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "Site Technical User Email is required",
                              validate: (value) => validateEmail(value) === null
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Site Technical User Email *"
                                type="email"
                                fullWidth
                                error={!!fieldState.error || !!techUserEmailError}
                                helperText={fieldState.error?.message || techUserEmailError || "Enter a valid email address"}
                                onChange={(e) => {
                                  field.onChange(e);

                                  // Perform validation
                                  const error = validateEmail(e.target.value);
                                  setTechUserEmailError(error);
                                  setIsTechUserEmailValid(!error);
                                }}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Controller
                            name="siteTechnicalUserName"
                            control={control}
                            defaultValue=""


                            rules={{ required: 'Site Technical User Name is required' }}  // Added required validation
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Site Technical User Name *"
                                fullWidth

                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Controller
                            name="siteTechnicalUserPhone"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'Site Technical User Phone is required',
                              validate: (value) => {
                                const error = validatePhoneNumber(value);
                                return error ? error : true;
                              }
                            }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                label="Site Technical User Phone *"
                                fullWidth
                                placeholder="+XX (XXX) XXX-XXXX"
                                error={!!fieldState.error || !!techUserPhoneError}
                                helperText={
                                  fieldState.error?.message ||
                                  techUserPhoneError ||
                                  (isTechUserPhoneTyping ? "Continue typing..." : "Format: +XX (XXX) XXX-XXXX")
                                }
                                onChange={(e) => {
                                  field.onChange(e);
                                  setIsTechUserPhoneTyping(true);

                                  // Perform validation
                                  const error = validatePhoneNumber(e.target.value);
                                  setTechUserPhoneError(error);
                                  setIsTechUserPhoneValid(!error);
                                }}
                                onBlur={() => {
                                  field.onBlur();
                                  setIsTechUserPhoneTyping(false);

                                  // Check if empty on blur
                                  if (!field.value) {
                                    setTechUserPhoneError('Site Technical User Phone is required');
                                    setIsTechUserPhoneValid(false);
                                  }
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </>
                )}
            </>
          )}

          {(requestType === 'Bandwidth Upgrade/Downgrade') && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 4,
              mb: 2,
              gap: 2,
              "& .MuiButton-root": {
                minWidth: 100,
                fontWeight: 500,
                px: 3,
                py: 1,
                borderRadius: 1.5,
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover:not(:disabled)": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                }
              }
            }}>
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={handleSave}
                disabled={isSaving}
                startIcon={isSaving ? <CircularProgress size={20} /> : null}
              >
                {isSaving ? "Saving..." : "Save as Draft"}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate('/')}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={
                  (grmNumberError !== null) ||
                  (debtorError !== null) ||
                  (oeNameError !== null) ||
                  (costCentreError !== null) ||
                  (customerPhoneError !== null) ||
                  (techUserPhoneError !== null) ||
                  (techUserEmailError !== null) ||
                  (getValues().grmDemandNumber && !isGrmNumberValid) ||
                  (getValues().debtor && !isDebtorValid) ||
                  (getValues().oeName && !isOeNameValid) ||
                  (getValues().costCentre && !isCostCentreValid) ||
                  (getValues().customerContactPhone && !isCustomerPhoneValid) ||
                  (getValues().siteTechnicalUserPhone && !isTechUserPhoneValid) ||
                  (getValues().siteTechnicalUserEmail && !isTechUserEmailValid) ||
                  (showAdditionalFields && selectedCircuits.length > 0 && !hasValidBandwidths()) ||
                  (showAdditionalFields && getValues().grmDemandNumber && getValues().debtor &&
                    getValues().oeName && !getValues().siteId)
                }
              >
                Submit
              </Button>
            </Box>
          )}
        </form>
      </Box>

      {/* Dialog Notifications */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isSubmitting} disableBackdropClick={true} disableEscapeKeyDown={true}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4 }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography>Submitting your request...</Typography>
          <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
            This may take a few moments
          </Typography>
        </DialogContent>
      </Dialog>
      <Dialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)}>
        <DialogTitle>Save as Draft?</DialogTitle>
        <DialogContent>
          <Typography>
            Your request will be saved as a draft and can be completed later.
            {!isUpdateMode && " You'll be able to find it in the Track Requests page."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaveDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSaveAsDraft}
            color="primary"
            variant="contained"
            disabled={isSaving}
          >
            Save as Draft
            {isSaving && <CircularProgress size={20} sx={{ ml: 1 }} />}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update the cost dialog with larger font */}
      <Dialog open={costDialogOpen} onClose={() => setCostDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" component="div">
              {estimatedCost?.standard ? 'Cost Approval' : 'Preliminary Cost Estimate'}
            </Typography>
            {estimatedCost?.upgradeType && estimatedCost.upgradeType !== "none" && (
              <Chip
                label={estimatedCost.upgradeType === "soft" ? "Soft Bandwidth Upgrade" : "Hard Bandwidth Upgrade"}
                color={estimatedCost.upgradeType === "soft" ? "success" : "warning"}
                size="small"
              />
            )}
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Add bandwidth upgrade explanation */}
          {estimatedCost?.upgradeType && estimatedCost.upgradeType !== "none" && (
            <Alert severity={estimatedCost.upgradeType === "soft" ? "info" : "warning"} sx={{ mb: 2 }}>
              <AlertTitle>
                {estimatedCost.upgradeType === "soft" ? "Soft Bandwidth Upgrade" : "Hard Bandwidth Upgrade"}
              </AlertTitle>
              <Typography variant="body2">
                {estimatedCost.upgradeType === "soft"
                  ? "This is a soft bandwidth upgrade request. The current router can handle the requested bandwidth."
                  : "This is a hard bandwidth upgrade request. A router upgrade is needed to handle the requested bandwidth."}
              </Typography>
            </Alert>
          )}

          {/* Standard vs Non-Standard Notice */}
          {estimatedCost?.standard === false && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              <AlertTitle>Non-Standard Request</AlertTitle>
              <Typography variant="body2">
                Some cost information is missing or unavailable. This is a preliminary estimate.
                We will provide you with an exact quote within 2 working weeks for your review and approval.
              </Typography>
            </Alert>
          )}

          <Box sx={{ mb: 2 }}>
            {/* Total Cost or Cost Range */}
            {estimatedCost?.standard ? (
              <Typography variant="h6" gutterBottom>
                Total Estimated Cost: €{estimatedCost?.total?.toFixed(2)}
              </Typography>
            ) : (
              <Typography variant="h6" gutterBottom>
                Estimated Cost Range: €{estimatedCost?.total?.toFixed(2)} - €{estimatedCost?.upperRangeTotal?.toFixed(2)}
              </Typography>
            )}

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>View Cost Breakdown</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          SD-WAN Circuit(s) (908138)
                          <InfoTooltip description={costComponentDescriptions.sdWanCircuits} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.sdWanCircuits?.toFixed(2) || "0.00"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          SD-WAN Management (908134)
                          <InfoTooltip description={costComponentDescriptions.sdWanManagement} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.sdWanManagement?.toFixed(2) || "0.00"}</TableCell>
                      </TableRow>
                      <TableRow>
  <TableCell>
    {(() => {
      // Use selectedRouterOption if available, otherwise fall back to cost result
      if (selectedRouterOption) {
        const details = getRouterDetails(selectedRouterOption.model);
        return `SD-WAN Router ${details.size} (${details.material_number})`;
      }
      
      // Fallback to routers from estimatedCost
      const routers = Object.entries(estimatedCost?.details?.routerCosts || estimatedCost?.routerCosts || {});
      
      if (routers.length > 0) {
        const routerModel = routers[0][0]; // First router model name
        const details = getRouterDetails(routerModel);
        return `SD-WAN Router ${details.size} (${details.material_number})`;
      }
      
      return "SD-WAN Router S/M/L/XL (908137)"; // Fallback
    })()}
    <InfoTooltip description={costComponentDescriptions.sdWanRouter} />
  </TableCell>
  <TableCell align="right">
    €{(estimatedCost?.breakdown?.sdWanRouter?.toFixed(2) || '0.00')}
  </TableCell>
</TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          SD-WAN IMACD (OTC Provider) (908374)
                          <InfoTooltip description={costComponentDescriptions.sdWanImacd} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.sdWanImacd?.toFixed(2) || "0.00"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Integrator Effort (Accenture) (905513)
                          <InfoTooltip description={costComponentDescriptions.accentureEffort} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.accentureEffort?.toFixed(2) || "0.00"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          SDWAN effort for bandwidth upgrade (2 PD) (908374)
                          <InfoTooltip description={costComponentDescriptions.sdWanEffort} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.sdWanEffort?.toFixed(2) || "361.30"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          ODM team effort (905513)
                          <InfoTooltip description={costComponentDescriptions.odmTeamEffort} />
                        </TableCell>
                        <TableCell align="right">€{estimatedCost?.breakdown?.odmTeamEffort?.toFixed(2) || "924.00"}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                {/* Add note about material numbers */}
                <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#666', fontStyle: 'italic' }}>
                  Note: Numbers in brackets denote material numbers.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {estimatedCost?.details?.circuitDetails && estimatedCost.details.circuitDetails.length > 0 && (
              <Accordion sx={{ mt: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Circuit Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Circuit ID</TableCell>
                          <TableCell>New Bandwidth</TableCell>
                          <TableCell>Option Used</TableCell>
                          <TableCell align="right">MRC (€)</TableCell>
                          <TableCell align="right">NRC (€)</TableCell>
                          <TableCell>Router Model</TableCell>
                          <TableCell>Upgrade Type</TableCell> {/* New column */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {estimatedCost.details.circuitDetails.map((circuit, index) => (
                          <TableRow key={index}>
                            <TableCell>{circuit.id}</TableCell>
                            <TableCell>{circuit.newBandwidth}</TableCell>
                            <TableCell>{circuit.option || 'N/A'}</TableCell>
                            <TableCell align="right">{circuit.mrc?.toFixed(2) || 'N/A'}</TableCell>
                            <TableCell align="right">{circuit.nrc?.toFixed(2) || 'N/A'}</TableCell>
                            {/* Replace it with this */}
                            <TableCell>
                              {circuit.routerModel || circuit.router_model}
                              {(circuit.routerModel || circuit.router_model) && (
                                <Typography variant="caption" display="block" color="text.secondary">
                                  ({getRouterDetails(circuit.routerModel || circuit.router_model).size},
                                  Material Number {getRouterDetails(circuit.routerModel || circuit.router_model).material_number})
                                </Typography>
                              )}
                              {(circuit.upgradeType === "hard" || circuit.upgrade_type === "hard") && circuit.newRouterModel && (
                                <>
                                  <Typography variant="body2" color="primary">
                                    ➡️ {circuit.newRouterModel}
                                  </Typography>
                                  <Typography variant="caption" display="block" color="primary">
                                    ({getRouterDetails(circuit.newRouterModel).size},
                                    Material Number: {getRouterDetails(circuit.newRouterModel).material_number})
                                  </Typography>
                                </>
                              )}
                            </TableCell>
                            <TableCell>
                              {circuit.upgradeType && (
                                <Chip
                                  label={circuit.upgradeType === "soft" ? "Soft" : "Hard"}
                                  color={circuit.upgradeType === "soft" ? "success" : "warning"}
                                  size="small"
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )}

            {estimatedCost?.details?.routerCosts && Object.keys(estimatedCost.details.routerCosts).length > 0 && (
              <Accordion sx={{ mt: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Router Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Router Model</TableCell>
                          <TableCell>Size</TableCell>
                          <TableCell>Material No.</TableCell>
                          <TableCell align="right">Cost (€)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(estimatedCost.details.routerCosts).map(([model, cost], index) => (
                          <TableRow key={index}>
                            <TableCell>{model}</TableCell>
                            <TableCell>{getRouterDetails(model).size}</TableCell>
                            <TableCell>{getRouterDetails(model).material_number}</TableCell>
                            <TableCell align="right">{Number(estimatedCost?.breakdown?.sdWanRouter || cost).toFixed(2)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )}

            {estimatedCost?.details?.errors && estimatedCost.details.errors.length > 0 && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                <AlertTitle>Calculation Warnings</AlertTitle>
                <List dense>
                  {estimatedCost.details.errors.map((error, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={error} />
                    </ListItem>
                  ))}
                </List>
              </Alert>
            )}

            {/* Non-Standard Request Additional Message */}
            {estimatedCost?.standard === false && (
              <Alert severity="info" sx={{ mt: 2 }}>
                <AlertTitle>Next Steps</AlertTitle>
                <Typography variant="body2">
                  We will come back to you within 2 working weeks with a quote for your review and approval.
                </Typography>
              </Alert>
            )}
          </Box>
           <RouterSelectionSection />
          <Typography variant="body1" sx={{ fontSize: '1rem', fontWeight: 500, mt: 2 }}>
            {estimatedCost?.standard
              ? 'Do you want to approve and submit this request?'
              : 'Do you want to submit this request and get a quotation?'}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCostDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleApprove} // CHANGED: handleSave -> handleApprove
            color="primary"
            variant="contained"
            disabled={isSaving || isCalculatingCosts}
          >
            {estimatedCost?.standard
              ? 'Approve & Submit'
              : 'Submit & Get Quotes'}
            {(isSaving || isCalculatingCosts) && (
              <CircularProgress size={20} sx={{ ml: 1 }} />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add this new dialog for calculation loading */}
      <Dialog open={isCalculatingCosts} disableBackdropClick={true} disableEscapeKeyDown={true}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4 }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6">Work in Progress...</Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Wait for Few Moments
          </Typography>
        </DialogContent>
      </Dialog>


    </Layout>
  );
};

export default NewRequest;

